<!-- Part of the SPARKL educational activity system, Copyright 2024 by Pepper Williams -->
<template><div class="k-lpe-lesson-edit"><div v-if="initialized">

	<!-- note magic constant for padding max-height, so that editor scrolls properly -->
	<div style="font-size:16px; line-height:20px; padding-bottom:48px; overflow:auto"> <!-- ; max-height:calc(100vh - 168px); -->
		<div class="k-lpe-alba-outer-outer mt-2">
			<!-- MENU FOR LESSON COMPONENTS/STAGES -->
			<div class="k-lpe-alba-menu-stages" v-if="standards.length>0 || edit_without_standards">
				<k-hover v-slot:default="{hover}"><div class="k-lpe-alba-menu-stage-outer" :class="menu_stage_css('title')" :style="hover?'opacity:1':''">
					<div v-bind="standards_component_left_bind()" @click="go_to_stage('title')">
						<k-icon style="width:20px" :color="`${standards_component.lc_color} darken-4`" small class="mr-2">fas fa-calendar-day</k-icon>
						<div class="k-lpe-alba-menu-stage-label">Title/Date</div>
						<k-spacer/>
						<k-icon>{{menu_stage_icon('title')}}</k-icon>
					</div>
				</div></k-hover>

				<k-hover v-slot:default="{hover}"><div class="k-lpe-alba-menu-stage-outer" :class="menu_stage_css('standards')" :style="hover?'opacity:1':''">
					<div v-bind="standards_component_left_bind()" @click="go_to_stage('standards')">
						<k-icon style="width:20px" :color="`${standards_component.lc_color} darken-4`" small class="mr-2">{{standards_component.lc_icon}}</k-icon>
						<div class="k-lpe-alba-menu-stage-label">{{ standards_component.lc_title }}</div>
						<k-spacer/>
						<k-icon>{{menu_stage_icon('standards')}}</k-icon>
					</div>
				</div></k-hover>

				<div v-for="(component, ci) in left_blocks" :key="component.lc_uuid">
					<!-- insert "groups" where needed -->
					<k-hover v-if="component.title" v-slot:default="{hover}"><div class="k-lpe-alba-menu-stage-outer" :class="menu_stage_css(component)" style="opacity:1">
						<div class="k-lpe-alba-menu-stage py-1" v-bind="left_block_component_bind(component)" @click="go_to_stage(component)">
							<div class="k-lpe-alba-menu-stage-label"><b style="font-weight:900">{{component.title}}</b></div>
						</div>
					</div></k-hover>

					<k-hover v-else v-slot:default="{hover}"><div class="k-lpe-alba-menu-stage-outer" :class="menu_stage_css(component)" :style="hover?'opacity:1':''">
						<div class="k-lpe-alba-menu-stage" v-bind="left_block_component_bind(component)" @click="go_to_stage(component)">
							<k-icon style="width:20px" :color="`${mdlph[component.lc_uuid].lc_color} darken-4`" small class="mr-2">{{mdlph[component.lc_uuid].lc_icon}}</k-icon>
							<div class="k-lpe-alba-menu-stage-label">{{mdlph[component.lc_uuid].lc_title}}</div>
							<k-spacer/>
							<k-icon>{{menu_stage_icon(component)}}</k-icon>
						</div>
					</div></k-hover>
				</div>
			</div>

			<!-- HOLDER FOR EACH STAGE, INCLUDING TITLE, STANDARDS, SPARKL ACTIVITY, AND RESOURCES -->
			<div class="k-lpe-alba-content"><div class="k-lpe-alba-content-inner">
				<!-- TITLE/DATE -->
				<div v-bind="standards_component_right_bind()" style="display:block;">
					<div class="d-flex align-center py-1">
						<!-- as of now, at least, we only show an editor for the human_code if we have a human code (it would come from satchel) -->
						<div v-if="edited_lesson.human_code" class="mr-2" style="flex:0 0 120px">
							<k-text-field background-color="#fff" style="font-weight:bold" hide-details outlined 
								v-model="edited_lesson.human_code"
								label="Code"
							></k-text-field>
						</div>
						<div style="flex:1 0 auto">
							<k-text-field background-color="#fff" style="font-weight:bold" hide-details outlined 
								ref="title_textfield" 
								v-model="edited_lesson.lesson_title"
								label="Title"
							></k-text-field>
						</div>
						<div v-if="lesson_class!='template'" class="ml-2 mr-2" style="flex:0 0 140px">
							<k-menu ref="lesson_date_menu" v-model="lesson_date_menu" :close-on-content-click="false" :return-value.sync="edited_lesson.lesson_date" transition="scale-transition" offset-y min-width="290px">
								<template v-slot:activator="{on}"><k-text-field background-color="#fff" outlined hide-details v-model="lesson_date_formatted" label="Start Date" append-icon="fas fa-calendar-day" @click:append="lesson_date_menu=true" readonly v-on="on"></k-text-field></template>
								<k-date-picker v-model="edited_lesson.lesson_date" no-title scrollable>
									<k-btn text color="primary" @click="no_lesson_date">No Date</k-btn>
									<k-spacer></k-spacer>
									<k-btn text color="primary" @click="lesson_date_menu=false">Done</k-btn>
								</k-date-picker>
							</k-menu>
						</div>
						<div v-if="lesson_class!='template'&&lesson_date_formatted" class="mr-2" style="flex:0 0 140px">
							<k-menu ref="lesson_date_end_menu" v-model="lesson_date_end_menu" :close-on-content-click="false" :return-value.sync="edited_lesson.lesson_date_end" transition="scale-transition" offset-y min-width="290px">
								<template v-slot:activator="{on}"><k-text-field background-color="#fff" outlined hide-details v-model="lesson_date_end_formatted" label="End Date" append-icon="fas fa-calendar-day" @click:append="lesson_date_end_menu=true" readonly v-on="on"></k-text-field></template>
								<k-date-picker v-model="edited_lesson.lesson_date_end" no-title scrollable>
									<k-btn text color="primary" @click="no_lesson_date_end">No Date</k-btn>
									<k-spacer></k-spacer>
									<k-btn text color="primary" @click="lesson_date_end_menu=false">Done</k-btn>
								</k-date-picker>
							</k-menu>
						</div>
						<div style="width:220px">
							<k-select outlined background-color="#fff" hide-details
								v-model="edited_lesson.lp_component_scheme" 
								label="Instructional Model"
								:items="lp_component_schemes_select"
								@change="lp_component_scheme_changed"
							></k-select>
						</div>
					</div>
				</div>

				<!-- STANDARDS -->
				<div v-bind="standards_component_right_bind()" style="display:block">
					<div class="d-flex align-center">
						<k-icon class="k-lpe-alba-section-header-icon" :color="`${standards_component.lc_color} darken-4`" @click="go_to_stage('standards')">{{standards_component.lc_icon}}</k-icon>
						<div class="k-lpe-alba-section-header-text mr-2" @click="go_to_stage('standards')">{{ standards_component.lc_title }}</div>
						<k-btn v-if="standards.length>0" small icon aria-label="Standards" class="mr-2" :color="`${standards_component.lc_color} darken-4`" @click="toggle_stage_edit('standards')"><k-icon style="font-size:20px">fas {{edited_lesson.standards_showing?'fa-angles-up':'fa-angles-down'}}</k-icon></k-btn>
						<draggable v-bind="drag_options" v-model="edited_lesson.standards" @end="drag_complete" class="d-flex flex-wrap my-1">
							<CASEItemBtn v-for="(s) in standards" :key="s.identifier" :btn_color="s.is_secondary?'#666':'primary'" :item="s" @click="align_to_standard(s)" @delete="remove_standard(s)" small :show_move_icon="edited_lesson.standards_showing&&standards.length>1" :show_delete_icon="edited_lesson.standards_showing" :outer_class="'ma-1'" />
						</draggable>
						<k-btn v-show="!edited_lesson.standards_showing" small :color="`${standards_component.lc_color} darken-4`" class="my-1 ml-4" dark @click="align_to_standard('primary')"><k-icon class="mr-1" small>fas fa-plus</k-icon>Add</k-btn>
						<div v-if="standards.length==0" class="k-lpe-alba-section-instructions" style="display:block" v-html="standards_component.lc_guidance"></div>
						<k-spacer/>
						<div v-if="standards.length==0 && is_new_lesson && !edit_without_standards" class="ml-2">
							<k-btn small color="#444" dark class="k-tight-btn k-nocaps-btn" style="height:40px!important;" @click="edit_without_standards_clicked"><div class="my-2">Edit Lesson Plan<br>without choosing standards</div></k-btn>
						</div>
					</div>
					<div k-expand-transition-XX><div v-show="edited_lesson.standards_showing" class="mb-2" :class="{ 'k-collapse-fast': fast_collapse_standards }">
						<div class="d-flex align-center mt-2 mb-4">
							<k-tooltip bottom><template v-slot:activator="{on}"><k-btn v-on="on" small :text="new_standard_is_secondary" color="primary" class="k-tight-btn k-nocaps-btn mr-2" dark @click="align_to_standard('primary')"><k-icon class="mr-1" small>fas fa-plus</k-icon>Add PRIMARY Alignment</k-btn></template>Note that PRIMARY alignments will be used to help generate relevant suggestions in future sections.</k-tooltip>
							<k-btn small :text="!new_standard_is_secondary" color="#666" class="k-tight-btn k-nocaps-btn" dark @click="align_to_standard('secondary')"><k-icon class="mr-1" small>fas fa-plus</k-icon>Add SECONDARY Alignment</k-btn>
						</div>
						<div v-for="(s) in standards" :key="s.identifier">
							<div class="d-flex k-lesson-standard-fullstatement mb-1">
								<CASEItemBtn @click="align_to_standard(s)" @delete="remove_standard(s)" :btn_color="s.is_secondary?'#666':'primary'" :item="s" small :outer_class="'mr-2'" />
								<div>
									<div v-html="U.marked_latex(s.fullStatement)"></div>
									<div v-if="s==first_primary_standard && standard_supplemental_information" class="fr-view k-lesson-standard-suppinfo">
										<div class="k-lesson-standard-suppinfo-header"><b>{{supp_info_header}}</b></div>
										<StumpyDiv 
											:min_height="72" 
											:no_transition="true"
											:uuid="s.identifier+'-alba'"
										>
											<div class="px-2 pb-2" v-html="standard_supplemental_information"></div>
										</StumpyDiv>
									</div>
								</div>
							</div>
						</div>
					</div></div k-expand-transition-XX>
					<div class="k-lpe-alba-section-buttons" v-if="edited_lesson.standards_showing&&standards.length>0&&!standards_done_clicked">
						<k-btn small color="#444" dark @click="stage_done_clicked('standards', 'next')"><k-icon style="font-size:20px" class="mr-2">far fa-circle-check</k-icon> Done</k-btn>
					</div>
				</div>

				<div v-if="!component_open_for_editing() && (!is_new_lesson || standards.length > 0 || edit_without_standards)" class="k-lpe-alba-button-instructions">Click the <k-icon color="#fff" class="mx-1" style="margin-top:-8px">fas fa-edit</k-icon> buttons below to plan sections of your Lesson</div>

				<!-- LESSON COMPONENTS -->
				<div v-for="(component, ci) in right_blocks" :key="component.lc_uuid" class="k-lpe-alba-content-section" 
					v-if="!(component.group_footer && !(!is_new_lesson || standards.length > 0 || edit_without_standards))"
					:class="section_stage_css(component)" 
					:style="section_stage_style(component)" 
				>

					<!-- Group Headers -->
					<div v-if="component.group_header">
						<div class="d-flex align-center">
							<k-btn x-small color="#333" dark class="mr-2" 
								v-if="show_group_header_hide_show(component)"
								style="width:64px"
								@click="toggle_component_group_showing($event, component)"
							>
								{{group_showing[component.lc_uuid]?'Hide':'Show'}}
								<k-icon small class="ml-1">fas {{group_showing[component.lc_uuid]?'fa-caret-up':'fa-caret-down'}}</k-icon>
							</k-btn>
							<b style="font-weight:900">{{component.title}}</b>
						</div>
						<!-- buttons for opening editors -->
						<div class="d-flex align-center justify-center flex-wrap">
							<k-btn v-for="(gc, ci) in component.group_components" :key="gc" small
								v-if="show_component_group_btn(gc)"
								class="k-lpe-menu_stage_btn k-tight-btn k-nocaps-btn mx-2 my-1"
								:class="component_open_for_editing(gc) ? 'elevation-4':'elevation-0'"
								:color="`${component.color} darken-4`"
								:text="!component_open_for_editing(gc)&&component_open_for_editing()"
								:outlined="!component_open_for_editing(gc)&&!component_open_for_editing()"
								:dark="component_open_for_editing(gc)"
								@click="toggle_stage_edit(gc)"
							>
								<k-icon small class="mr-1">{{mdlph[gc].lc_icon}}</k-icon>
								<span>{{mdlph[gc].lc_title}}</span>
								<k-icon x-small class="ml-2">fas fa-edit</k-icon>
							</k-btn>
						</div>
					</div>

					<!-- Sections -->
					<div v-if="!component.group_header&&!component.group_footer">
						<div class="d-flex align-center">
							<k-icon class="k-lpe-alba-section-header-icon" @click="go_to_stage(component)" :color="`${mdlph[component.lc_uuid].lc_color} darken-4`">{{mdlph[component.lc_uuid].lc_icon}}</k-icon>
							<div class="k-lpe-alba-section-header-text" v-bind="right_block_component_bind(component)" @click="go_to_stage(component)">{{mdlph[component.lc_uuid].lc_title}}</div>
							<k-btn x-small class="ml-3" :color="`${mdlph[component.lc_uuid].lc_color} darken-4`" dark @click="toggle_stage_edit(component)"><k-icon x-small class="mr-1">{{component.lc_open_for_editing?(component.lc_content?'far fa-check':'fas fa-xmark'):'fas fa-edit'}}</k-icon> {{component.lc_open_for_editing?'Done':'Edit'}}</k-btn>
							<div class="k-lpe-alba-section-instructions" v-html="component_guidance(component)"></div>
						</div>
						<div class="k-lpe-alba-section-summary-wrapper" v-if="section_text(component)">
							<StumpyDiv ref="lc_stumpy_div"
								:min_height="200" 
								:no_transition="true"
								:trigger="component.lc_content" 
								:uuid="'alba-editor-'+component.lc_uuid"
								@stumpy_toggle_show_full="component_stumpy_toggled(component.lc_uuid, $event)"
							>
								<div class="k-lpe-alba-section-summary fr-view" v-html="section_text(component)"></div>
							</StumpyDiv>
						</div>
						<div style="clear:both"></div> <!-- needed in case there is weird stuff in the section_text -->

						<!-- SUGGESTIONS/EDITOR -->
						<div k-expand-transition-XX><div class="k-lpe-alba-section-editor" v-show="component.lc_open_for_editing">

							<div v-if="first_primary_standard && standard_supplemental_information" v-show="component==last_edited_component"><div class="d-flex justify-center mb-4 mt-1">
								<div class="ml-2 mt-3 d-flex k-lesson-standard-fullstatement">
									<CASEItemBtn @click="show_standard(first_primary_standard)" btn_color="primary" :item="first_primary_standard" small :outer_class="'mr-2'" />
									<div k-expand-transition-XX><div v-show="standards_showing_in_component">
										<div v-html="U.marked_latex(first_primary_standard.fullStatement)"></div>
										<div class="fr-view k-lesson-standard-suppinfo">
											<div class="k-lesson-standard-suppinfo-header"><b>{{supp_info_header}}</b></div>
											<StumpyDiv 
												:min_height="72" 
												:no_transition="true"
												:uuid="first_primary_standard.identifier+'-alba'"
											>
												<div class="px-2 pb-2" v-html="standard_supplemental_information"></div>
											</StumpyDiv>
										</div>
									</div></div k-expand-transition-XX>
								</div>
								<k-btn v-if="standards.length>0" small icon aria-label="Standards" class="ml-1 mt-3" color="#000" @click="standards_showing_in_component=!standards_showing_in_component"><k-icon style="font-size:20px">fas {{standards_showing_in_component?'fa-angles-up':'fa-angles-down'}}</k-icon></k-btn>
							</div></div>

							<div v-for="(option, index) in component.lc_suggestions" :key="index">
								<div v-if="option=='---'&&index==0" style="margin-top:8px"></div>
								<div v-else-if="option=='---'&&index!=0" style="line-height:0px; border-top:1px solid #aaa"></div>
								<k-hover v-else v-slot:default="{hover}">
									<div class="k-lpe-alba-content-item my-1 py-1" :class="hover?'grey lighten-5':''">
									<k-icon color="indigo darken-4" small style="margin-top:2px">fas fa-robot</k-icon>
									<div style="flex: 1 1 auto; padding:0 8px 0px 8px" v-html="component_suggestion_html(component, option)"></div>
									<k-btn small icon aria-label="Add suggestion" class="mr-1 ml-1" @click="add_suggestion(component, index)"><k-icon color="green darken-4">fas fa-circle-check</k-icon></k-btn>
									<k-btn small icon aria-label="Remove Suggestion" class="mr-1 ml-1" @click="remove_suggestion(component, index)"><k-icon color="red darken-4">fas fa-circle-xmark</k-icon></k-btn>
								</div></k-hover>
							</div>

							<div v-if="stage_suggestible(component) && component.lc_generated_suggestion_summaries.length>0" class="k-lpe-alba-section-buttons">
								<div v-if="component.lc_suggestions.length>0" class="mr-2"><span class="white py-1 px-2" style="border-radius:5px; color:#666;"><i>Click <k-icon style="font-size:18px; margin-top:-2px" color="green darken-4">fas fa-circle-check</k-icon> to include suggestions in your lesson plan</i></span></div>
								<k-spacer/>
								<k-btn small class="k-tight-btn mr-2" :color="`${mdlph[component.lc_uuid].lc_color} darken-4`" dark :style="!stage_currently_suggestible(component)?'opacity:0.5':''" @click="make_component_suggestions(component)"><k-icon x-small class="mr-1">fas fa-robot</k-icon>{{component.lc_suggestions.length>0?'More Suggestions':`Suggest More ${mdlph[component.lc_uuid].lc_title_plural}`}}</k-btn>
								<k-btn v-if="component.lc_suggestions.length>0" small class="k-tight-btn elevation-0" color="red darken-4" dark @click="clear_suggestions(component)"><k-icon small class="mr-1">fas fa-xmark</k-icon>Clear all Suggestions</k-btn>
							</div>

							<div v-if="mdlph[component.lc_uuid].lc_options" class="mt-2 mxc-auto" style="width:540px">
								<k-select dense outlined background-color="#fff" hide-details
									v-model="component.lc_content" 
									:label="(component.lc_content||component.lc_option_other_chosen)?'':'Choose a value'"
									:items="mdlph[component.lc_uuid].lc_options"
									@change="lc_option_select_changed(component)"
								></k-select>
							</div>

							<div v-if="!mdlph[component.lc_uuid].lc_options||component.lc_option_other_chosen" class="mt-2">
								<froala-wrapper 
									v-model="component.lc_content" 
									:ref="`froala_${component.lc_uuid}`" 
									:config="editor_config(component)" 
									:parameter_object="component" 
									:parent_component="self_reference"
									parameter="lc_content" 
									@model_value_updated="lc_content_changed(component, $event)" 
								/>
							</div>

							<div class="k-lpe-alba-section-buttons">
								<k-btn v-if="true||(component.lc_content&&!mdlph[component.lc_uuid].lc_gpt_model_prompt)" small color="#444" dark @click="stage_done_clicked(component)"><k-icon style="font-size:20px" class="mr-2">{{(component.lc_content) ? 'far fa-circle-check' : 'fas fa-xmark'}}</k-icon> Done</k-btn>
								<k-btn v-if="show_next_section_btns" class="ml-2" small color="#444" dark @click="stage_done_clicked(component, 'next')">Next Section<k-icon small class="ml-2">fas fa-forward</k-icon></k-btn>

								<k-spacer v-if="component.lc_uuid=='materials'" />

								<k-btn small class="k-tight-btn ml-2" color="#555" dark :text="component.lc_uuid!='materials'" @click="create_resource_start(component)"><k-icon small class="mr-1">fas fa-plus-circle</k-icon>Add A {{component.lc_uuid=='materials' ? 'Digital' : 'Featured'}} Resource</k-btn>
								<!-- TODO: reorder needs to work for any component -->
								<k-btn v-if="component.lc_uuid=='materials'" v-show="edited_lesson.resources.length>0" small class="ml-2 k-tight-btn" color="#666" dark @click="resource_reorder_open=true"><k-icon x-small class="mr-1">fas fa-arrows-alt-v</k-icon>Reorder Resources</k-btn>

								<k-spacer/>

								<k-btn v-if="stage_suggestible(component) && component.lc_generated_suggestion_summaries.length==0" small class="k-tight-btn mr-2" :color="`${mdlph[component.lc_uuid].lc_color} darken-4`" dark :style="!stage_currently_suggestible(component)?'opacity:0.5':''" @click="make_component_suggestions(component)"><k-icon x-small class="mr-1">fas fa-robot</k-icon>{{`Suggest ${mdlph[component.lc_uuid].lc_title_plural}`}}</k-btn>

								<div v-if="stage_suggestible(component) && component.lc_unaltered_ai" class="k-lpe-ai-generated-warning elevation-3">
									<k-icon>fas fa-robot</k-icon>
									<div><b>LLM-generated:</b>  please check for accuracy and make edits if necessary.</div>
									<k-btn x-small color="pink darken-4" class="ml-2" dark @click="lc_content_changed(component, true)"><k-icon x-small style="margin-right:2px">fas fa-check</k-icon>OK</k-btn>
								</div>

								<k-btn v-if="component.lc_uuid=='materials'" small class="ml-2 k-tight-btn" color="purple darken-4" dark @click="open_lesson_sparkl_creator"><k-icon small class="mr-1">fas fa-star</k-icon>{{(edited_lesson.sparkl_activity_id==0) ? 'Create a' : 'Update'}} {{site_config.sparkl_app_name}} Activity</k-btn> <!-- {{site_config.sparkl_app_name}} -->
							</div>
						</div></div k-expand-transition-XX>

						<!-- RESOURCES FOR COMPONENTS *OTHER THAN* MATERIALS when not open for editing -->
						<div v-if="asset_list[component.lc_uuid].length>0" class="k-lesson-resource-collection mt-3 mb-2">
							<div v-for="(asset) in asset_list[component.lc_uuid]" :key="asset.resource_id||asset.lesson_id" class="k-resource-collection-activity-wrapper">
								<ResourceCollectionItem 
									ref="resource_collection_item" 
									:lesson_context="edited_lesson" :lp_context="lp" :unit_context="unit"
									:item="asset" 
									:option_overrides="resource_option_overrides(asset)"
									@edit_item_saved="edit_item_saved"
									@edit_item_cancel="edit_item_cancel"
									@remove_item="remove_item"
									@lesson_opened="linked_lesson_opened"
									@lesson_closed="linked_lesson_closed"
								/>
							</div>
						</div>
					</div>
				</div>

			</div></div>
		</div>

	</div>
	<div class="px-2 py-2 k-lpe-lesson-editor-buttons">
		<k-tooltip bottom><template v-slot:activator="{on}"><k-btn v-if="(course_code||lesson_shifted)&&enable_lesson_shift" v-on="on" class="mr-2" fab x-small dark color="secondary" @click="$emit('shift_lesson')"><k-icon small>fas {{lesson_shifted?'fa-angles-left':'fa-angles-right'}}</k-icon></k-btn></template>Shift Lesson</k-tooltip>
		<k-btn color="secondary" class="k-tight-btn" @click="edit_lesson_cancel"><k-icon small class="mr-2">fas fa-times</k-icon>{{is_new_lesson?'Cancel':'Close Editor'}}&nbsp;</k-btn>

		<k-tooltip top v-if="show_gpt_stats"><template v-slot:activator="{on}"><div v-on="on" class="d-flex align-center ml-4 mr-2" style="font-size:14px;">
			{{edited_lesson.gpt_suggestion_accepts}} / {{edited_lesson.gpt_suggestion_requests}}
			<div class="grey darken-2 white--text px-2 mx-1" style="border-radius:4px">{{edited_lesson.gpt_input_tokens}} + {{edited_lesson.gpt_output_tokens}} = {{gpt_cost}}¢</div>
			<div class="mx-1">{{ gpt_model }}</div>
		</div></template>
			{{edited_lesson.gpt_suggestion_accepts}} suggestions accepted / {{edited_lesson.gpt_suggestion_requests}} suggestion requests<br>
			Total cost for model <b>{{gpt_model}}</b>: {{gpt_cost}}¢ (<b>${{(gpt_cost * 1000 / 100).toFixed(2)}}</b> for 1000 similar lessons)<br>
		</k-tooltip>

		<k-spacer/> 
		<div v-show="just_saved" class="k-lpe-alba-saved-indicator mr-4"><nobr><k-icon color="#fff" style="margin-top:-4px; font-size:18px" class="mr-2">fas fa-save</k-icon>SAVED</nobr></div>
		<k-spacer/> 

		<!-- menu for additional functionality -->
		<k-menu><template v-slot:activator="{on}"><k-btn v-on="on" icon aria-label="Show menu" color="secondary" class="mr-2"><k-icon>fas fa-ellipsis-v</k-icon></k-btn></template>
			<k-list dense>
				<k-list-item @click="give_feedback">
					<k-list-item-icon><k-icon small color="#666">fas fa-comment</k-icon></k-list-item-icon>
					<k-list-item-title>Provide feedback / report a bug…</k-list-item-title>
				</k-list-item>
				<k-list-item @click="check_for_new_resources">
					<k-list-item-icon><k-icon small color="#666">fas fa-gear</k-icon></k-list-item-icon>
					<k-list-item-title>Convert links to resources…</k-list-item-title>
				</k-list-item>
				<k-list-item @click="show_gpt_stats=!show_gpt_stats">
					<k-list-item-icon><k-icon small color="#666">fas fa-chart-simple</k-icon></k-list-item-icon>
					<k-list-item-title>Show/hide cost statistics (BETA)</k-list-item-title>
				</k-list-item>
			</k-list>
		</k-menu>
		<k-btn v-show="dirty" color="primary" class="ml-3 k-tight-btn" @click="save_lesson"><k-icon small class="mr-2">fas fa-save</k-icon>Save&nbsp;</k-btn>
		<k-btn color="primary" class="ml-3 k-tight-btn" @click="save_and_close"><k-icon small class="mr-2">fas fa-check</k-icon>Save and Close Editor</k-btn>
	</div>

	<!-- resource reorderer -->
	<k-dialog v-if="resource_reorder_open" v-model="resource_reorder_open" max-width="680" persistent scrollable>
		<k-card>
			<k-card-title style="border-bottom:1px solid #999"><b style="font-weight:900">Reorder Resources</b></k-card-title>
			<k-card-text class="pt-3" style="background-color:#eee">
				<draggable v-bind="{animation:300}" v-model="edited_lesson.resources" @end="save_lesson">
					<div v-for="(resource) in edited_lesson.resources" :key="resource.resource_id" style="border:1px solid #333; padding:4px; margin:4px 0; background-color:#fff; border-radius:6px; cursor:move" class="d-flex align-center">
						<div class="mx-2 k-lesson-editor-resource-reorderer-handle"><k-icon small>fas fa-arrows-alt-v</k-icon></div>
						<div style="font-size:14px;" v-html="resource.description"></div>
					</div>
				</draggable>
			</k-card-text>
			<k-card-actions class="pa-3" style="border-top:1px solid #999">
				<k-spacer></k-spacer>
				<k-btn color="secondary" @click="resource_reorder_open=false">Done</k-btn>
			</k-card-actions>
		</k-card>
	</k-dialog>

	<!-- SPARKL ACTIVITY CREATOR -->
	<k-dialog v-if="sparkl_creator_open" v-model="sparkl_creator_open" max-width="760" persistent scrollable>
		<k-card class="purple lighten-5">
			<!-- <div class="purple lighten-5"> -->
				<div class="d-flex align-center mx-2">
					<k-icon class="k-lpe-alba-section-header-icon mr-2" color="purple darken-4">fas fa-star</k-icon>
					<div class="k-lpe-alba-section-header-text purple--text text--darken-4 mr-2 py-2"><b>{{site_config.sparkl_app_name}} Lesson Activity</b></div>
					<k-spacer/>
					<div v-if="sparkl_activity_created" class="ml-3"><b>Created:</b> Activity ID {{edited_lesson.sparkl_activity_id}}</div>
					<k-spacer/>
					<k-btn v-if="sparkl_activity_created" small color="#444" class="mr-2" dark @click="open_lesson_sparkl_activity"><k-icon small class="mr-2">fas fa-up-right-from-square</k-icon> Open Activity</k-btn>
				</div>
				<div style="background-color:#fff; padding:8px; margin-top:4px;">
					<div class="d-flex align-start mx-2 mb-3" style="max-width:720px; font-size:15px; line-height:20px">
						<k-icon color="light-blue" small class="mr-2" style="margin-top:0px; font-size:20px;">fas fa-info-circle</k-icon>
						<div><i>
							<span v-if="edited_lesson.sparkl_activity_id==0">To create a {{site_config.sparkl_app_name}} student activity to accompany this lesson plan, choose the lesson components you would like to create exercises for, then click <nobr>“CREATE ACTIVITY”</nobr> below. You will then be able to modify and continue building the activity, then administer the activity with your students, using the {{site_config.sparkl_app_name}} teacher interface.</span>
							<span v-else>You can update the {{site_config.sparkl_app_name}} student activity that accompanies this lesson plan by clicking <nobr>“UPDATE ACTIVITY”</nobr> below. You can modify and continue building the activity, then administer the activity with your students, using the {{site_config.sparkl_app_name}} teacher interface.</span>
						</i></div>
					</div>
					<div v-for="(component, ci) in lesson_plan" :key="component.lc_uuid" v-if="mdlph[component.lc_uuid].lc_offer_to_include_in_sparkl&&component.lc_content" class="mx-2">
						<div class="d-flex align-start mt-2 pt-2" style="border-top:1px solid #ccc">
							<div style="flex:0 0 200px"><k-checkbox class="shrink mt-0 pt-0 d-inline-block" hide-details v-model="component.lc_include_in_sparkl"><template v-slot:label><b style="color:#000">{{mdlph[component.lc_uuid].lc_title}}</b></template></k-checkbox></div>
							<div style="font-size:14px; line-height:18px;">{{sparkl_include_help_text(mdlph[component.lc_uuid].lc_sparkl_include_help_text)}}</div>
						</div>
					</div>
					<div class="d-flex mt-2 pt-2" style="border-top:1px solid #ccc">
						<k-btn color="#444" dark @click="sparkl_creator_open=false"><k-icon style="font-size:20px" class="mr-2">far fa-circle-check</k-icon> Done</k-btn>
						<k-spacer/>
						<k-btn color="purple darken-4" dark @click="create_lesson_sparkl_activity"><k-icon small class="mr-2">fas fa-star</k-icon> {{(edited_lesson.sparkl_activity_id==0) ? 'Create' : 'Update'}} Lesson Activity</k-btn>
					</div>
				</div>
			<!-- </div> -->
		</k-card>
	</k-dialog>

	<ResourceSearch v-if="show_search" 
		:dialog_title="`Search for Resource${resource_search_home_lesson?'':'s'} to Add to Lesson`"
		:home_lesson="resource_search_home_lesson"
		:home_unit="unit"
		:home_collection_base="lp"
		:allow_add_from_home="true"
		:max_items="resource_search_home_lesson?1:0"
		:existing_resources="resource_search_home_lesson?[]:edited_lesson.resources"
		:adding_to_lesson="true"
		@add_items_from_search="add_items_from_search" @dialog_cancel="search_cancel" 
	/> <!-- if we're adding to froala text, we want to give the user the option of choosing resources from this lesson, and we don't want to show existing resources -->

	<LPCSuggestionPromptEditor v-if="prompt_editor_params" 
		:params="prompt_editor_params"
		@proceed="make_component_suggestions2"
		@dialog_cancel="prompt_editor_params=null"
	/>

</div></div></template>

<script>
import goTo from 'vuetify/lib/services/goto'
import draggable from 'vuedraggable'
import { mapState, mapGetters } from 'vuex'
import FroalaResourcesMixin from '../../js/FroalaResourcesMixin'
import LessonEnhancedMixin from './LessonEnhancedMixin'
import LPCSuggestionPromptEditor from './LPCSuggestionPromptEditor'
import CASEItemBtn from '../standards/CASEItemBtn'
import StumpyDiv from '../utilities/StumpyDiv'
import '../resources/from_sparkl/auto-blank-utilities.js'
import '../resources/from_sparkl/Exercise.js'

export default {
	name: 'LessonEditor',
	components: { 
		ResourceCollectionItem: () => import('../resources/ResourceCollectionItem'),
		ResourceSearch: () => import('../resources/ResourceSearch'),
		draggable, CASEItemBtn, StumpyDiv, LPCSuggestionPromptEditor },
	mixins: [FroalaResourcesMixin, LessonEnhancedMixin],
	props: {
		original_lesson: { required: true },	// if 'new' we're creating a new lesson
		original_lp_variant: { type: String, required: false, default() { return '' }},	// if set to 'A', we've converted from variant A to B (so save even if nothing else is changed)
		lesson_class: { type: String, required: false, default() { return '' }},	// 'teacher' or 'template'; masters have their own editor
		course_code: { type: String, required: false, default() { return '' }},
		lp_unit_id: { type: Number, required: false, default() { return 0 }},
		lesson_shifted: { type: Boolean, required: false, default() { return false }},
		enable_lesson_shift: { type: Boolean, required: false, default() { return true }}
	},
	data() { return {
		initialized: false,
		edited_lesson: null,
		lesson_master: null,
		resource_being_edited: false,
		show_search: false,
		resource_search_home_lesson: null,

		student_description_showing: false,
		lesson_components_showing: true,
		resources_showing: false,
		standards_showing: false,
		standards_showing_in_component: true,
		satchel_open: false,
		fast_collapse_standards: false,
		edit_without_standards: false,

		last_edited_component: null,
		last_clicked_component: null,

		resource_edit_component: null,
		resource_reorder_open: false,
		sparkl_creator_open: false,

		lesson_date_menu: false,
		lesson_date_end_menu: false,

		stringified_original_lesson: '',

		drag_options: {
			animation: 200,
			handle: ".k-move-handle",
		},

		// https://openai.com/api/pricing/
		gpt_model_options: [
			{ value: 'gpt-4o-mini', text: 'gpt-4o-mini', input_cost:0.150, output_cost:0.600 },
			{ value: 'gpt-4.1-nano', text: 'gpt-4.1-nano', input_cost:0.100, output_cost:0.400 },
			// { value: 'gpt-5-mini', text: 'gpt-5-mini', input_cost:0.250, output_cost:2.000 },
			// 8/14/2025: initial test of gpt-5-nano didn't return results in the same format as 4o-mini
			{ value: 'gpt-5-nano', text: 'gpt-5-nano', input_cost:0.050, output_cost:0.400 },
			// { value: 'gpt-5.1-chat-latest', text: 'gpt-5.1-chat-latest', input_cost:1.25, output_cost:10.00 },
			// { value: 'gpt-4o', text: 'gpt-4o', input_cost:5.000, output_cost:15.000 },
			// { value: 'gpt-3.5-turbo-0125', text: 'gpt-3.5-turbo-0125', input_cost:0.500, output_cost:1.500 },
			// { value: 'gpt-4-turbo', text: 'gpt-4-turbo', input_cost:10.000, output_cost:30.000 },
		],
		gpt_model: 'gpt-4.1-nano',
		// gpt_temperature: 0.4,
		// gpt_temperature: 1,		// 0-2; 0 = less variance; defaults to 1
		// gpt_frequency_penalty: 0,	// this is the default; setting this to non-0 would do something similar to gpt_temperature

		default_suggestions_to_request: 3,
		default_schema: {
			type: 'object',
			properties: {
				'output': {
					type: 'array',
					// items: { type: 'string' },
					items: { 
						type: "object",
						properties: {
							summary: { 
								type: "string",
								description: "A 1-6 word **summary** of the suggestion, which should include no punctuation."
							},
							suggestion_text: { 
								type: "string",
								description: "The **text of the suggestion**, without any introductory phrases or commentary."
								// note that the above may be altered in make_component_suggestions2
							},
						},
						required: ["summary", "suggestion_text"],
						additionalProperties: false
					},
					minItems: 3,
					maxItems: 3,
					description: `An array of exactly 3 suggestions.`
				}
			},
			required: ['output'],
			additionalProperties: false
		},

		default_min_vocab_suggestions: 4,
		default_max_vocab_suggestions: 8,
		vocab_schema: {
			type: "object",
			properties: {
				'output': {
					type: "array",
					items: { 
						type: "object",
						properties: {
							term: { type: "string" },
							definition: { type: "string" },
						},
						required: ["term", "definition"],
						additionalProperties: false
					},
					minItems: 4,
					maxItems: 8,
					description: `An array of 4-8 objects.`
				}
			},
			required: ['output'],
			additionalProperties: false
		},

		just_saved: false,
		standards_done_clicked: false,
		new_standard_is_secondary: false,

		enable_llm_beta: false,
		edit_llm_suggestion_prompts: false,
		prompt_editor_params: null,
	}},
	computed: {
		...mapState(['site_config', 'user_info', 'lesson_masters']),
		...mapGetters([]),
		// gpt_model: {		// currently fixed; see data attribute above
		// 	get() { 
		// 		return this.$store.state.lst.gpt_model 
		// 	},
		// 	set(val) { this.$store.commit('lst_set', ['gpt_model', val]) }
		// },
		gpt_temperature: {
			get() { return this.$store.state.lst.gpt_temperature },
			set(val) { this.$store.commit('lst_set', ['gpt_temperature', val]) }
		},
		dirty() {
			let o = this.edited_lesson.copy_for_save()
			let s = JSON.stringify(o)
			return (s != this.stringified_original_lesson)
		},
		standards_component() { return this.lesson_master.standards_component },
		lp_component_scheme() { return this.lesson_master?.lp_component_schemes[this.edited_lesson.lp_component_scheme] },
		scheme_edit_order() {
			if (empty(this.lp_component_scheme)) return []
			if (!empty(this.lp_component_scheme.edit_order)) return this.lp_component_scheme.edit_order
			// default: edit in the order specified by the stages
			let arr = []
			for (let group of this.lp_component_scheme.groups) {
				arr = [...arr, ...group.group_components]
			}
			return arr
		},
		mdlph() {
			let o = this.construct_mdlph()

			// for converted lessons, also include a value for each converted component
			for (let c of this.edited_lesson.lesson_plan) {
				if (!o[c.lc_uuid]) {
					o[c.lc_uuid] = {
						lc_title: c.lc_title || 'Lesson Component',
						lc_title_plural: c.lc_title || 'Lesson Component',
						lc_icon: 'fas fa-list-ul',
						lc_color: 'grey',
						lc_offer_to_include_in_sparkl: true,
						lc_sparkl_include_method: 'basic_content',
						lc_sparkl_include_help_text: 'The text you have entered, including any resource links, will be added as a Freeform exercise, which you can edit as needed in the $sparkl_app_name.',
					}
				}
			}
			return o
		},
		left_blocks() {
			let arr = []
			// put existing components in the order specified by the lp_component_scheme groups
			for (let group of this.lp_component_scheme.groups) {
				arr.push(group)

				for (let lc_uuid of group.group_components) {
					let lpc = this.lesson_plan.find(x=>x.lc_uuid == lc_uuid) 

					// on the left side, only show components that have been saved, or are open for editing
					// also always show 'materials', which might include resources
					if (lpc) {
						if (this.stage_status(lpc) == 'complete' || lpc.lc_open_for_editing || lc_uuid == 'materials') {
							arr.push(lpc)
						}
					}
				}
			}
			return arr
		},
		right_blocks() {
			// put components in the order specified by the lp_component_scheme groups -- both in the array of things to show on the right, and in edited_lesson.lesson_plan
			let rb_arr = []
			let updated_lpc_arr = []
			let groups = object_copy(this.lp_component_scheme.groups)
			for (let group of groups) {
				// push a "header" for the group
				let o = object_copy(group)
				o.lc_uuid
				o.group_header = true
				rb_arr.push(o)

				// now push each lpc for the group
				for (let lc_uuid of group.group_components) {
					let lpci = this.lesson_plan.findIndex(x=>x.lc_uuid == lc_uuid) 
					if (lpci > -1) {
						let lpc = this.lesson_plan.splice(lpci, 1)[0]
						updated_lpc_arr.push(lpc)
						rb_arr.push(lpc)
					} else {
						console.warn('couldn’t find lpc for ' + lc_uuid)
					}
				}

				// now push a "footer" for the group
				// group.lc_uuid += '_footer'
				// group.group_footer = true
				// rb_arr.push(group)
			}

			// if there are any lpcs left in this.lesson_plan, tack them on to the end of rb_arr
			for (let lpc of this.lesson_plan) {
				updated_lpc_arr.push(lpc)
			}

			// set possibly reordered lesson_plan array
			this.edited_lesson.lesson_plan = updated_lpc_arr

			// return the array of things to show on the right
			return rb_arr
		},
		lp_component_schemes_select() {
			let arr = []
			for (let key in this.lesson_master.lp_component_schemes) {
				// skip schemes that are marked as DELETE in site_config
				if (this.lesson_master.lp_component_schemes[key].deleted) continue

				arr.push({value:key, text:this.lesson_master.lp_component_schemes[key].label})
			}
			return arr
		},
		lesson_course_code() {
			if (this.original_lesson.course_code) return this.original_lesson.course_code
			else return this.course_code
		},
		lesson_lp_unit_id() {
			if (this.original_lesson.lp_unit_id) return this.original_lesson.lp_unit_id
			else return this.lp_unit_id
		},
		lp() { return this.$store.state.all_courses.find(x=>x.course_code==this.lesson_course_code) },
		unit() {
			if (!this.lp || this.lesson_lp_unit_id == 0) return null
			return this.lp.units.find(x=>x.lp_unit_id == this.lesson_lp_unit_id)
		},
		lesson_noun() {
			if (this.lesson_class == 'master') return 'Lesson Master'	// not used here
			else if (this.lesson_class == 'template') return 'Template Lesson'
			else return 'Lesson Plan'
		},
		is_new_lesson() { return this.original_lesson == 'new' || this.original_lesson.lesson_id == 0  },
		show_next_section_btns() {
			// show the buttons for "next section" in each section's editor interface IFF this lesson WASN'T copied from another lesson
			// logic: if the current user created a new lesson from scratch, we want to guide them through the lesson process;
			// but if the current user copied this from an existing lesson, the core of the lesson is already filled in
			return this.original_lesson.lesson_template_id == 0
		},
		lesson_date_formatted() {
			if (empty(this.edited_lesson)) return ''
			if (empty(this.edited_lesson.lesson_date)) return ''
			let d = new Date(this.edited_lesson.lesson_date + 'T00:00:00')
			return date.format(d, 'ddd MMM D')	// Tue Jan 9
		},
		lesson_date_end_formatted() {
			if (empty(this.edited_lesson)) return ''
			if (empty(this.edited_lesson.lesson_date_end)) return ''
			let d = new Date(this.edited_lesson.lesson_date_end + 'T00:00:00')
			return date.format(d, 'ddd MMM D')	// Tue Jan 9
		},
		// as of 8/15/2025, make users turn this on every time
		// edit_llm_suggestion_prompts: {
		// 	get() { return this.$store.state.lst.edit_llm_suggestion_prompts },
		// 	set(val) { this.$store.commit('lst_set', ['edit_llm_suggestion_prompts', val]) }
		// },
		// vapp.lesson_editor_component.show_gpt_stats = true
		show_gpt_stats: {
			get() { return this.$store.state.lst.show_gpt_stats },
			set(val) { this.$store.commit('lst_set', ['show_gpt_stats', val]) }
		},
		gpt_cost() {
			let md = this.gpt_model_options.find(x=>x.value == this.gpt_model)
			let x = (this.edited_lesson.gpt_input_tokens * md.input_cost) + (this.edited_lesson.gpt_output_tokens * md.output_cost)
			x = x / 1000000
			x = x * 100
			return x.toFixed(3)
		},
		chosen_standard_identifiers() {
			if (!this.edited_lesson) return []

			let arr = []
			for (let s of this.standards) {
				arr.push(s.identifier)
			}
			return arr
		},
		standards() { return this.edited_lesson?.standards },

		// split standards into primary and secondary
		primary_standards() { return this.standards?.filter(x=>!x.is_secondary) },
		secondary_standards() { return this.standards?.filter(x=>x.is_secondary) },

		lesson_plan() { return this.edited_lesson?.lesson_plan },
		sparkl_creatable() {
			for (let c of this.lesson_plan) {
				// only consider parts of the lp where lc_offer_to_include_in_sparkl is true
				let mc = this.master_component(c)
				if (mc.lc_offer_to_include_in_sparkl && c.lc_status == 'complete') return true
			}
			return false
		},
		sparkl_activity_created() { return this.edited_lesson.sparkl_activity_id != 0 },
		show_resources_component() {
			if (!this.edited_lesson) return false
			if (this.edited_lesson.resources_showing) return true
			if (this.materials_asset_list.length > 0) return true
			for (let c of this.lesson_plan) {
				if (c.lc_status == 'complete') return true
			}
			return false
		},
		supp_info_header() {
			return this.site_config.llp_supp_info_header || `Guidance from ${this.site_config.agency_name}`
		},
		self_reference() { return this },
	},
	watch: {
		chosen_standard_identifiers() {
			// console.log('chosen_standard_identifiers updated! ' + this.chosen_standard_identifiers.length)
			// if we're showing vapp.case_tree_component and the standard_identifiers get updated, push the change...
			if (vapp.case_tree_component && vapp.case_tree_component.set_chosen_items) {
				vapp.case_tree_component.set_chosen_items(this.chosen_standard_identifiers)
			}
		},
		'edited_lesson.lesson_date'(val) {
			if (this.$refs.lesson_date_menu) this.$refs.lesson_date_menu.save(this.edited_lesson.lesson_date)
		},
		'edited_lesson.lesson_date_end'(val) {
			if (this.$refs.lesson_date_end_menu) this.$refs.lesson_date_end_menu.save(this.edited_lesson.lesson_date_end)
		},
		original_lesson() {
			// when a new lesson is first saved, original_lesson will be changed to the newly-created lesson
			this.initialize_edited_lesson()
		},
	},
	created() {
	},
	mounted() {
		// console.warn('mounting LEE: ', object_copy(this.original_lesson))
		// for "variant B" / Enhanced Lesson / Lesson Plan Companion, the lesson master is hard-coded
		this.lesson_master = window.variant_b_lesson_master_data

		this.initialize_edited_lesson()

		// this used by the standards chooser hide_fn
		vapp.lesson_editor_component = this

		this.initialized = true

		this.activate_section_text_copy_btns()
	},
	methods: {
		initialize_edited_lesson() {
			this.show_lpc_start_blurb()
			if (this.is_new_lesson) {
				// start with what was passed in via the original_lesson
				this.edited_lesson = new Lesson(this.original_lesson, this.lesson_master)

				// set the new lesson's course_code and lp_unit_id to what we received
				this.edited_lesson.course_code = this.course_code
				this.edited_lesson.lp_unit_id = this.lp_unit_id

				setTimeout(x=>{
					// this.$refs.title_textfield.select()
					$(this.$refs.title_textfield.$el).find('input').select()
					$(this.$refs.title_textfield.$el).find('input').focus()
				}, 500)

			} else {
				this.edited_lesson = new Lesson(this.original_lesson, this.lesson_master)

				this.edit_without_standards = (this.standards.length == 0)

				// if we have vapp.lpc_stage_status, restore status (this is used when we first save a new lesson)
				if (!empty(vapp.lpc_stage_status)) {
					for (let comp of this.edited_lesson.lesson_plan) {
						comp.lc_showing = vapp.lpc_stage_status[comp.lc_uuid].lc_showing
						comp.lc_open_for_editing = vapp.lpc_stage_status[comp.lc_uuid].lc_open_for_editing
					}
					vapp.lpc_stage_status = null
				}
			}

			// if at least one standard is chosen, set the first not-completed, not-skipped stage as open_for_editing
			if (this.standards.length > 0) {
				// this.open_next_component_for_editing()
				// also show the standards, and set standards_done_clicked to true in this case
				// this.edited_lesson.standards_showing = true
				this.standards_done_clicked = true
			}

			this.stringified_original_lesson = JSON.stringify(this.edited_lesson.copy_for_save())
		},

		show_lpc_start_blurb() {
			if (this.$store.state.lpc_materials_warning_issued) return true
			this.$store.commit('set', ['lpc_materials_warning_issued', true])

			let llp_warning_start = this.site_config.llp_warning_start || `As you work through the LPC, please ensure that your instructional plan, as well as all materials you intend to use, align with your school and district policies and meet copyright requirements. You are responsible for confirming that everything you use in class is approved and compliant.`
			
			let text = `<div style="font-size:22px; font-weight:bold; display:flex; align-items:center; justify-content:space-between; margin-top:12px;">`
					+ `<div>Welcome to the ${this.site_config.app_name} Lesson Plan Companion (LPC)!</div>`
					+ `<i class="fas fa-dog k-lpe-dog-icon" style="margin-top:-5px"></i>`
				+ `</div>`
				+ `<div style="margin:20px 0 12px 0">`
					+ `The LPC is a teacher-driven tool designed to help you create a standards-aligned lesson plan that you’ll feel confident implementing with your students.`
				+ `</div>`
				+ `<div style="margin:0">`
					+ llp_warning_start
				+ `</div>`
			this.$alert({
				text: text,
				dialogMaxWidth: 680,
				acceptText: ' Got It',
				acceptIconAfter: 'fas fa-arrow-right',
			})
		},

		async show_lpc_stop_blurb() {
			if (this.$store.state.ignore_lpc_stop_warning) {
				return true
			}

			let llp_warning_finish = this.site_config.llp_warning_finish || `Before you put your lesson into practice, please take a moment to confirm that your instructional plan, and all materials you intend to use, align with your school and district policies and meet copyright requirements. You are responsible for ensuring that everything you bring into the classroom is approved and compliant.`

			let text = `<div style="font-size:22px; font-weight:bold; display:flex; align-items:center; justify-content:space-between; margin:12px 0 20px 0;">`
					+ `<div>Before you leave…</div>`
					+ `<i class="fas fa-dog k-lpe-dog-icon" style="margin-top:-5px"></i>`
				+ `</div>`
				+ llp_warning_finish

			let arr = await U.confirm_promise({
				text: text,
				dialogMaxWidth: 600,
				acceptText: 'Understood',
				acceptIcon: 'fas fa-circle-check',
				cancelText: 'Continue Editing',
				secondaryCheckbox: 'Don’t show this warning again',
				secondaryCheckboxInitiallyOn: false,
			})
			if (arr[1] == true) {
				this.$store.commit('set', ['ignore_lpc_stop_warning', true])
			}
			return arr[0]
		},

		component_open_for_editing(lc_uuid) {
			// if lc_uuid is empty, check to see if *anything* is open for editing
			if (empty(lc_uuid)) {
				return this.lesson_plan.find(x=>x.lc_open_for_editing) != null

			// else check to see if *this component* is open for editing
			} else {
				let c = this.lesson_plan.find(x=>x.lc_uuid == lc_uuid)
				return c?.lc_open_for_editing
			}
		},

		component_complete(lc_uuid) {
			let c = this.lesson_plan.find(x=>x.lc_uuid == lc_uuid)
			return c?.lc_complete
		},

		master_component(component) {
			return this.mdlph[component?.lc_uuid || component]
		},

		component_guidance(component) {
			let s = this.mdlph[component.lc_uuid].lc_guidance ?? ''

			// sub sparkl_app_name
			s = this.sparkl_include_help_text(s)

			// for the overview section, add some extra text if we haven't already skipped or completed this section
			// if (component.lc_uuid == 'overview' && empty(component.lc_content) && empty(component.lc_status)) s = s.replace(/<\/p>/, '<br><b>Note that this section, like all other sections of the LPC, is optional.<br>Feel free to skip to another section.</b></p>')
			return s
		},

		edit_without_standards_clicked() {
			this.edit_without_standards = true
			this.stage_done_clicked('standards', 'next')
		},

		toggle_component(ci, val) {
			if (typeof(val) != 'boolean') val = !this.lesson_plan[ci].lc_showing
			this.lesson_plan[ci].lc_showing = val
		},

		editor_config(component) {
			let o = {
				placeholderText: '',
				// initOnClick: true,
				toolbarInline: false,
				paragraphFormat: {
					H3: 'Section Header',
					N: 'Normal',
					BLOCKQUOTE: 'Block Quote',
				    PRE: 'Code',
				},
				heightMax: '70vh',
				zIndex: 1000,	// needed for to make table menus show up properly
			}
			// if lc_text_format isn't 'paragraphs' (i.e. 'line' or 'list'), use <br>'s as line separators
			let mc = this.master_component(component)
			if (mc?.lc_text_format != 'paragraphs') o.enter = FroalaEditor.ENTER_BR

			// if lc_prompt_height is specified, add it to o
			if (!empty(mc?.lc_prompt_height)) {
				o.heightMin = mc.lc_prompt_height
			}

			let config = U.get_froala_config(o)

			// add the insert resource btn at the front of the moreRich buttons
			config.toolbarButtons.moreRich.buttons.unshift('insert_resource')
			config.toolbarButtons.moreRich.buttonsVisible += 1
			// // and remove the 'insertHR' btn, if there
			// let i = config.toolbarButtons.moreRich.buttons.findIndex(x=>x=='insertHR')
			// if (i > -1) {
			// 	config.toolbarButtons.moreRich.buttons.splice(i, 1)
			// 	if (i <= (config.toolbarButtons.moreRich.buttonsVisible-1)) config.toolbarButtons.moreRich.buttonsVisible -= 1
			// }
			// also remove the 'paragraphFormat' btn from the moreRich buttons
			let i = config.toolbarButtons.moreRich.buttons.findIndex(x=>x=='paragraphFormat')
			if (i > -1) {
				config.toolbarButtons.moreRich.buttons.splice(i, 1)
				if (i <= (config.toolbarButtons.moreRich.buttonsVisible-1)) config.toolbarButtons.moreMisc.buttonsVisible -= 1
			}

			return config
		},

		model_response_editor_config(component) {
			// modeled on sparkl window.cr_froala_config
			let toolbarButtons = {
				moreMisc: {buttons: ['bold', 'italic', 'formatUL', 'formatOL', 'emoticons', 'insertLink', 'insertmathtype', 'undo', 'redo', 'clearFormatting', 'fullscreen',
					'underline', 'strikeThrough', 'align', 'sparklfontsize', 'textColor', 'backgroundColor', 'insertTable' ], buttonsVisible: 11},
			}

			return U.get_froala_config({
				toolbarButtons: toolbarButtons,
				placeholderText: 'Enter your response here',
				heightMin:100,
				heightMax:300,
				enter: FroalaEditor.ENTER_BR,
			})
		},

		// update the froala value for the lesson component. this needs to be called when we change the component's content value
		update_froala_value(component, flag) {
			// we're targeting 'froala_XXX' most of the time, but if flag is 'cr_model', target 'froala_model_response_XXX'
			let ref = 'froala_'
			if (flag == 'cr_model') ref = 'froala_model_response_'
			ref += component.lc_uuid

			if (!this.$refs[ref] || !this.$refs[ref][0] || !this.$refs[ref][0].set_model_value) return
			this.$refs[ref][0].set_model_value(component.lc_content)
		},

		lc_content_changed(component, explicit) {
			// when user edits a component, make sure that lc_unaltered_ai is false (lc_unaltered_ai will have been set to true if a suggestion was accepted)
			this.$store.commit('set', [component, 'lc_unaltered_ai', false])
			if (explicit === true) {
				this.save_lesson('no_spinner')
			}
		},

		no_lesson_date() {
			// if you clear the starting lesson date, you can't have an ending lesson date
			this.edited_lesson.lesson_date = ''
			this.edited_lesson.lesson_date_end = ''
			this.lesson_date_menu = false
		},

		no_lesson_date_end() {
			this.edited_lesson.lesson_date_end = ''
			this.lesson_date_end_menu = false
		},

		remove_item(asset, confirmed) {
			// note that the asset could be either a resource or a lesson
			let asset_id = asset.resource_id || asset.lesson_id

			// check to see if the asset is anywhere in another component's asset_ids or the text of the lesson (unless already confirmed)
			if (!confirmed) {
				let found = 0
				let position_string
				for (let ci = 0; ci < this.lesson_plan.length; ++ci) {
					let comp = this.lesson_plan[ci]
					let mdc = this.master_component(comp)
					if (comp.lc_content.indexOf(asset_id) > -1) {
						++found
						position_string = sr('<nobr>“$1”</nobr>', mdc.lc_title)
					}
					if (comp.lc_asset_ids.find(x=>x==asset_id)) {
						++found
						position_string = sr('<nobr>“$1”</nobr>', mdc.lc_title)
					}
				}

				if (found) {
					let found_string = (found==1) ? '' : 'at least ' + found + ' times'

					this.$confirm({
					    title: 'Are you sure?',
					    text: sr('This resource is linked $1 from your Lesson text, in the $2 portion of the Lesson. Are you sure you want to remove the resource? If you do so, the resource link(s) will also be removed from the Lesson Component(s).', found_string, position_string),
					    acceptText: 'Remove Resource',
						acceptColor: 'red',
						dialogMaxWidth: 600
					}).then(y => {
						this.remove_item(asset, true)
					}).catch(n=>{console.log(n)}).finally(f=>{})
					return
				}
			}

			// remove from lesson text and other components' asset_ids
			let re = new RegExp('<link class="k-lesson-component-resource-link[^>]+' + asset_id + '[^>]+>', 'g')
			for (let comp of this.lesson_plan) {
				let s = comp.lc_content.replace(re, '')
				if (s != comp.lc_content) {
					comp.lc_content = s
					this.update_froala_value(comp)
				}

				let i = comp.lc_asset_ids.findIndex(x=>x==asset_id)
				if (i > -1) {
					comp.lc_asset_ids.splice(i, 1)
				}
			}
			this.edited_lesson.student_description = this.edited_lesson.student_description.replace(re, '')

			// if the removed resource is the "lesson activity" (url == sparkl_activity_id), clear sparkl_activity_id
			if (asset.type == 'sparkl' && asset.url == this.edited_lesson.sparkl_activity_id) {
				this.edited_lesson.sparkl_activity_id = 0
			}

			// splice the asset out; it could be in resources or lessons (yes, lessons can have other lessons linked to them)
			let i = this.edited_lesson.resources.findIndex(x=>x.resource_id==asset.resource_id)
			if (i > -1) this.edited_lesson.resources.splice(i, 1)

			i = this.edited_lesson.lessons.findIndex(x=>x.lesson_id==asset.lesson_id)
			if (i > -1) this.edited_lesson.lessons.splice(i, 1)

			// then immediately save
			this.save_lesson('no_spinner')
		},

		create_resource_start(component) {
			if (this.edited_lesson.lesson_id == 0) {
				this.$alert('You must save the lesson before adding resources.')
				return
			}

			// if this is initiated from the froala editor, or from a section other than 'materials',
			// show the user the option of inserting resources from the lesson
			if (this.fco || component.lc_uuid != 'materials') {
				this.resource_search_home_lesson = this.edited_lesson
			}

			// note which component we're adding to
			this.resource_edit_component = component

			// show the search dialog
			this.show_search = true
		},

		add_items_from_search(items) {
			// if we were adding to a lesson text, call insert_resource_selected, then close the interface on next tick
			let added_from_froala = false
			if (this.fco) {
				added_from_froala = true
				this.insert_resource_selected(items[0].value)
				this.$nextTick(x=>this.search_cancel())
			}
			
			// get a reference to the default collection (we should always have this)
			let dc = this.$store.getters.my_default_collection
			let save_default_collection = false

			// go through each item...
			for (let item of items) {
				let updated_resource
				if (item.type == 'resource') {
					updated_resource = new Resource(item.value)
					
					// unless we're adding to lesson text, 
					if (!added_from_froala) {
						// add to lesson resources, unless it's already there
						if (!this.edited_lesson.resources.find(x=>x.resource_id == updated_resource.resource_id)) {
							this.edited_lesson.resources.push(updated_resource)
						}
					}

					// if this is a resource sparkl created by the signed-in user, add to the default collection as well
					if (updated_resource.creator == this.user_info.user_id) {
						if (!empty(dc?.units[1]?.resources?.length)) {
							dc.units[1].resources.push(updated_resource)
							save_default_collection = true
						}
					}

				} else {	// lesson
					updated_resource = new Lesson(item.value)
					
					// unless we're adding to lesson text, 
					if (!added_from_froala) {
						// add to lesson lessons, unless it's already there
						if (!this.edited_lesson.lessons.find(x=>x.lesson_id == updated_resource.lesson_id)) {
							this.edited_lesson.lessons.push(updated_resource)
						}
					}
				}

				// unless we're adding to lesson text, 
				if (!added_from_froala) {
					// if we were adding to a component (not 'materials'), add to the component's lc_asset_ids
					if (this.resource_edit_component?.lc_uuid != 'materials') {
						this.resource_edit_component.lc_asset_ids.push(updated_resource.lesson_id || updated_resource.resource_id)
					}
				}
			}

			this.resource_edit_component = null

			// save the default collection if needed
			if (save_default_collection) {
				this.$store.dispatch('save_default_collection_resources').then(() => {
					// console.warn('save_default_collection_resources done')
				})
			}

			this.$inform(`${items.length} ${U.ps('resource', items.length)} added`)

			// save, but wait a tick in case this is a new lesson, in which case we may need to wait for the text of whatever we added to be updated
			setTimeout(x=>this.save_lesson('no_spinner'), 50)
		},

		search_cancel() {
			// call insert_resource_cancel in case we were inserting a resource in a lesson component (note: this will not do anything if we just called insert_resource_selected
			this.insert_resource_cancel()
			this.resource_search_home_lesson = null
			this.show_search = false
		},

		// this is called from FroalaResourcesMixin, when the user clicks on a resource icon from the froala editor
		froala_inserted_resource_clicked(fco, resource_id, resource_description, froala_resource_link_id) {
			this.show_resource(resource_id, froala_resource_link_id)
		},

		// this is called from ResourceEditor, via ResourceCollectionItem
		edit_item_saved(args) {
			let updated_resource = new Resource(args.updated_resource)

			// the resource editor will have saved the resource to the db; splice it to edited_lesson.resources
			let index = this.edited_lesson.resources.findIndex(x=>x.resource_id == updated_resource.resource_id)
			if (index > -1) {
				this.edited_lesson.resources.splice(index, 1, updated_resource)
				// the lesson data won't change, so we have to update the original_unit too
				if (!this.is_new_lesson) this.original_lesson.resources.splice(index, 1, new Resource(updated_resource))
				// save lesson edits right away whenever a new resource is updated
				this.save_lesson('no_spinner')

			} else {
				// this can happen if the resource is added to the text but not the resources list
				index = this.asset_list?.materials?.find(x=>x.resource_id == updated_resource.resource_id)
				if (empty(index) || index == -1) {
					console.error('Possible error: couldn’t find resource in edited_lesson.resources or edited_lesson.asset_list')
				}
			}
		},

		edit_item_cancel(args) {
			// we don't have to do anything here
		},

		reorder_resources() {
			this.save_lesson('no_spinner')
			this.resource_reorder_open = false
		},

		///////////////////////////////////
		// Standards
		align_to_standard(arg) {
			// use quick_align if specified in site_config (we will eventually always use quick_align)
			if (this.site_config.use_quick_align) {
				this.align_to_standard_quick(arg)
				return
			}

			// always show the full text of standards when we start aligning
			this.edited_lesson.standards_showing = true

			let start_item = null
			if (typeof(arg) == 'string') {
				// if we get a string argument, it tells us whether aligned standards are to be primary or secondary
				this.new_standard_is_secondary = (arg == 'secondary') ? true : false

				// in this case, if we already have one or more standards, make the start item the last standard chosen
				if (this.standards.length > 0) start_item = this.standards[this.standards.length-1]

			} else {
				// else the arg is the "start item" for SatchelEmbed
				start_item = arg
			}

			let data = { framework_identifier: '', item_identifier: '' }

			if (start_item?.framework_identifier) {
				data.framework_identifier = start_item.framework_identifier
			} else {
				// HACK: trace up through parents looking for a case_framework_identifier value (e.g. in CourseView); if found, use it
				let parent = this.$parent
				while (parent) {
					if (parent.case_framework_identifier) { data.framework_identifier = parent.case_framework_identifier; break; }
					parent = parent.$parent
				}
			}

			if (start_item?.identifier) {
				data.item_identifier = start_item.identifier
			} else {
				// if the lesson has a course_case_identifier, send it
				// if (this.edited_lesson.course_case_identifier) data.item_identifier = this.edited_lesson.course_case_identifier

				// HACK: trace up through parents looking for a course_case_identifier value (e.g. in CourseView); if found, use it as item_identifier
				let parent = this.$parent
				while (parent) {
					if (parent.course_case_identifier) { data.item_identifier = parent.course_case_identifier; break; }
					parent = parent.$parent
				}
			}

			// add current lesson standards as selected items
			if (this.standards.length > 0) {
				data.selected_items = []
				for (let standard of this.standards) data.selected_items.push(standard.identifier)
			}

			let show_data = { 
				// set embed_hide_callback_fn to toggle satchel_open off when the user closes the chooser
				embed_hide_callback_fn: ()=>{ this.satchel_open = false },
				// set hide_fn to hide the standards chooser if/when the editor is no longer visible
				hide_fn: ()=>{ return ($(vapp.lesson_editor_component?.$el).is(':visible') == false) } 
			}

			this.satchel_open = true

			vapp.$refs.satchel.execute('show', show_data).then(()=>{
				vapp.$refs.satchel.execute('load_framework', data).then(()=>{
					vapp.$refs.satchel.execute('chooser', {chooser_mode: true}).then((aligned_item) => {
						// if we already have this item aligned, remove the standard
						let i = this.standards.findIndex(o=>o.identifier==aligned_item.cfitem.identifier)
						if (i > -1) {
							this.standards.splice(i, 1)
							// re-initialize the chooser, showing the framework for the item we removed
							this.align_to_standard({framework_identifier: aligned_item.framework_identifier})

						} else {
							// Add the standard, along with the incoming framework_identifier, childOf, and sequenceNumber. use the learning progression CASE_Item structure for standards; this is a bit simpler than the full CFItem structure
							let o = new CASE_Item(aligned_item)

							// set is_secondary for the new standard
							o.is_secondary = this.new_standard_is_secondary

							this.standards.push(o)
							// re-initialize the chooser, showing the framework for the item we added
							this.align_to_standard({framework_identifier: aligned_item.framework_identifier})

							// set edit_without_standards to true, so that if the user later removes the standard they'll still see the editing interface
							this.edit_without_standards = true
						}
						
						// unless this is a new lesson, call save_lesson here (if it *is* a new lesson, don't do this here because we have to close satchel when we save a new lesson
						if (!this.is_new_lesson) {
							this.save_lesson('no_spinner')
						}
					})
				})
			})
		},

		// align_to_standard using new "quick_align" functionality
		align_to_standard_quick(arg) {
			// always show the full text of standards when we start aligning
			this.edited_lesson.standards_showing = true

			let base_item = null
			if (typeof(arg) == 'string') {
				// if we get a string argument, it tells us whether aligned standards are to be primary or secondary
				this.new_standard_is_secondary = (arg == 'secondary') ? true : false

				// in this case, if we already have one or more standards, make the start item the last standard chosen
				// TODO: last *primary or secondary* standard chosen
				if (this.standards.length > 0) base_item = this.standards[this.standards.length-1]

			} else {
				// else the arg is the "base item" for SatchelEmbed
				base_item = arg
			}

			let quick_align_payload = { 
				choice_fn: this.align_to_standard_choice_made
			}

			// if this is the first time we're opening the satchel quick_align interface (from any part of cureum)...
			if (!this.$store.state.quick_align_previously_opened) {
				// if we have a base item, use its framework_identifier as the initial competency universe for quick_align
				if (base_item?.framework_identifier) {
					quick_align_payload.framework_identifier = base_item.framework_identifier
				} else {
					// HACK: trace up through parents looking for a case_framework_identifier value (e.g. in CourseView); if found, use it
					let parent = this.$parent
					while (parent) {
						if (parent.case_framework_identifier) { 
							quick_align_payload.framework_identifier = parent.case_framework_identifier
							break
						}
						parent = parent.$parent
					}
				}

				// if the lesson has a course_case_identifier, send it
				// if (this.edited_lesson.course_case_identifier) quick_align_payload.item_identifier = this.edited_lesson.course_case_identifier

				// HACK: trace up through parents looking for a course_case_identifier value (e.g. in CourseView); if found, use it as item_identifier
				let parent = this.$parent
				while (parent) {
					if (parent.course_case_identifier) { 
						quick_align_payload.start_branch_identifier = parent.course_case_identifier
						break
					}
					parent = parent.$parent
				}

				// if site_config says to do so, only show outcomes as alignment options by default (the user can change this once in the satchel quick_align interface)
				if (this.site_config.align_assets_to_outcomes_only == 'yes') {
					quick_align_payload.outcomes_only = true
				}

				this.$store.commit('set', ['quick_align_previously_opened', true])
			}
			// if this *isn't* the first time we're opening the interface, we don't send this info, which causes satchel to use whatever settings the user used last time

			// send current standards in the quick_align existing_alignments format
			if (this.standards.length > 0) {
				quick_align_payload.existing_alignments = {}
				for (let standard of this.standards) {
					quick_align_payload.existing_alignments[standard.identifier] = {
						framework_identifier: standard.framework_identifier,
						cfitem: standard.copy_for_save(),
						aligned: true,
					}
				}
			}

			// if we have at least a title, send lesson data in suggestion_params
			if (!empty(this.edited_lesson.lesson_title)) {
				// if we have a 'topics' section of the lesson_plan, send it in alignmentMetadata
				let topics = ''
				let topics_section = this.edited_lesson.lesson_plan?.find(x=>x.lc_uuid=='topics')
				if (topics_section && !empty(topics_section.lc_content) && !empty(U.html_to_text(topics_section.lc_content))) {
					topics = topics_section.lc_content
				}
				quick_align_payload.resource_universe_item = {
					// I don't think it really matters what we send in here as the resourceSourcedId
					resourceSourcedId: `L${this.edited_lesson.lesson_id || '12345'}`,
					title: this.edited_lesson.lesson_title,
					alignmentMetadata: [topics],
					// educationLevel: [],
				}
				quick_align_payload.alignment_metadata_description = (this.mdlph.topics?.lc_title || '')
			}

			// if site_config says to do so, only show outcomes as alignment options by default (the user can change this once in the satchel quick_align interface)
			if (this.site_config.align_assets_to_outcomes_only == 'yes') {
				quick_align_payload.outcomes_only = true
			}

			// set hide_fn to hide the standards chooser if/when the editor is no longer visible
			let show_payload = { 
				start_size: 'large',
				hide_fn: ()=>{ return ($(vapp.lesson_editor_component?.$el).is(':visible') == false) } 
			}

			// console.warn('new align_to_standard', quick_align_payload)
			// return

			vapp.$refs.satchel.execute('show', show_payload).then(()=>{
				vapp.$refs.satchel.execute('quick_align', quick_align_payload).then(x=>{
					// user clicked "done" from quick align interface	
				})
			})
		},

		align_to_standard_choice_made(data) {
			console.warn('cureum align_to_standard_choice_made', data)
			// if we already have this item aligned, remove the standard
			let i = this.standards.findIndex(o=>o.identifier==data.cfitem.identifier)
			if (i > -1) {
				this.standards.splice(i, 1)

			} else {
				// Add the standard, along with the incoming framework_identifier, childOf, and sequenceNumber. use the learning progression CASE_Item structure for standards; this is a bit simpler than the full CFItem structure
				let o = new CASE_Item({
					framework_identifier: data.framework_identifier,
					cfitem: data.cfitem,
					// TODO: we want to get the following too
					childOf: data.childOf,	// item identifier
					sequenceNumber: data.sequenceNumber,	// integer
				})

				// set is_secondary for the new standard
				o.is_secondary = this.new_standard_is_secondary
				// console.warn('this.new_standard_is_secondary', this.new_standard_is_secondary)

				this.standards.push(o)

				// set edit_without_standards to true, so that if the user later removes the standard they'll still see the editing interface
				this.edit_without_standards = true
			}

			// unless this is a new lesson, call save_lesson here (if it *is* a new lesson, don't do this here because we have to close satchel when we save a new lesson
			if (!this.is_new_lesson) {
				this.save_lesson('no_spinner')
			}
		},

		remove_standard(s, confirmed) {
			// console.log(s)
			let i = this.standards.findIndex(o=>o.identifier==s.identifier)
			if (i > -1) {
				if (!this.confirmed_standard_delete && !confirmed) {
					this.$confirm({
						title: 'Remove Standard Alignment',
						text: 'Are you sure you want to remove this standard alignment from the Lesson Plan?',
						acceptText: 'Remove',
						acceptColor: 'red',
					}).then(y => {
						this.remove_standard(s, true)
						this.confirmed_standard_delete = true
					}).catch(n=>{console.log(n)}).finally(f=>{})
					return
				}

				this.standards.splice(i, 1)
				this.save_lesson('no_spinner')
				
				// if we have satchel open, we have to re-show aligned standards
				if (this.satchel_open) this.align_to_standard(s)
			}
		},

		drag_complete(evt) {
			// standards will have been reordered; just need to save
			this.save_lesson('no_spinner')
		},

		show_standard(s) {
			let data = { 
				framework_identifier: s.framework_identifier, 
				item_identifier: s.identifier 
			}

			// add current lesson standards as selected items
			if (this.standards.length > 0) {
				data.selected_items = []
				for (let standard of this.standards) data.selected_items.push(standard.identifier)
			}

			let show_data = { 
				// set embed_hide_callback_fn to toggle satchel_open off when the user closes the chooser
				embed_hide_callback_fn: ()=>{ this.satchel_open = false },
				// set hide_fn to hide the standards chooser if/when the editor is no longer visible
				hide_fn: ()=>{ return ($(vapp.lesson_editor_component?.$el).is(':visible') == false) } 
			}

			this.satchel_open = true

			vapp.$refs.satchel.execute('show', show_data).then(()=>{
				vapp.$refs.satchel.execute('load_framework', data).then(()=>{
				})
			})
		},

		///////////////////////////////////
		flash_save_indicator() {
			setTimeout(x=>{
				// flash the 'saved' message
				this.just_saved = true
				setTimeout(x=>this.just_saved = false, 2000)
			}, 10)
		},

		save_and_close() {
			this.save_lesson('and_close')
		},

		save_lesson(flag) {
			// if this is a new lesson...
			if (this.is_new_lesson) {
				// have to close satchel if it was opened, because this component will be re-opened with the newly-saved lesson
				if (vapp.$refs.satchel.connection_established) {
					vapp.$refs.satchel.execute('hide')
				}
			}

			// unless flag is 'and_close', remember the following values for each stage so we can restore when the editor re-opens
			if (flag != 'and_close') {
				let stage_status = {}
				for (let comp of this.lesson_plan) {
					stage_status[comp.lc_uuid] = {
						lc_showing: comp.lc_showing,
						lc_open_for_editing: comp.lc_open_for_editing,
					}
				}
				vapp.lpc_stage_status = stage_status
			}

			this.edited_lesson.lesson_title = $.trim(this.edited_lesson.lesson_title)

			// trim all lesson_plan content strings
			for (let comp of this.lesson_plan) {
				let s = U.trim_blank_html(comp.lc_content)
				if (s != comp.lc_content) {
					// console.warn(`trimmed ${comp.lc_uuid}: “${comp.lc_content}”`)
					comp.lc_content = s
					this.update_froala_value(comp)
				}
			}

			let new_stringified_lesson = JSON.stringify(this.edited_lesson.copy_for_save())

			// remove the k-last-lesson-quick-look-resource class from any link
			new_stringified_lesson = new_stringified_lesson.replace(/\s*k-last-lesson-quick-look-resource\s*/g, '')

			if (new_stringified_lesson == this.stringified_original_lesson) {
				// if original variant was A, save even if nothing changed
				if (this.original_lp_variant != 'A') {
					console.warn('NOT SAVED because no change')
					// if flag is 'and_close', close lesson editor
					if (flag == 'and_close') {
						this.edit_lesson_cancel()
					// else flash the save indicator if this isn't a new lesson
					} else if (!this.is_new_lesson) {
						this.flash_save_indicator
					}
					return
				}
			}

			if (empty(this.edited_lesson.lesson_title)) {
				// show an alert, unless flag is 'no_spinner' and we've already given a warning
				if (!(flag == 'no_spinner' && this.no_title_warning_given)) {
					this.$alert('Enter a title for your Lesson Plan to auto-save.')
					this.no_title_warning_given = true
				}
				return
			}

			let payload = {
				lesson_class: this.lesson_class,
				lesson_data: JSON.parse(new_stringified_lesson),
				suppress_loader: (flag == 'no_spinner')
			}
			this.$store.dispatch('save_lesson', payload).then((result)=>{
				// updated data will be returned; emit it to the parent component, along with the flag
				// (the flag might be 'and_close', in which case the parent should take care of closing the editor)
				this.$emit('edit_lesson_saved', {updated_lesson: result.updated_lesson, flag:flag, edited_lesson:this.edited_lesson})	// pass edited_lesson so we can preserve *_showing values

				// save new stringified original lesson
				this.stringified_original_lesson = new_stringified_lesson
				this.flash_save_indicator()
			})
		},

		async edit_lesson_cancel(confirmed) {
			if (confirmed !== true && this.stringified_original_lesson != JSON.stringify(this.edited_lesson.copy_for_save())) {
				this.$confirm({
				    text: 'You appear to have made changes. Are you sure you want to close the lesson editor with out saving these changes?',
					acceptText: 'Don’t Save',
				}).then(y => {
					this.edit_lesson_cancel(true)
				}).catch(n=>{console.log(n)}).finally(f=>{})
				return
			}

			// show closing message unless this is a new lesson (if it's new and we're here, the user is canceling)
			if (!this.is_new_lesson) {
				let result = await this.show_lpc_stop_blurb()
				if (!result) return
			}

			this.edited_lesson.reset_checked_out_for_edit()
			// emit edit_lesson_cancel, sending a flag saying that we've already checked the lesson in
			this.$emit('edit_lesson_cancel', 'already_checked_in')
		},

		//////////////////////////////
		stage_suggestible(component) {
			// if we don't have master data for the component, we can't make suggestions
			let mdc = this.master_component(component)
			if (!mdc) return false

			// if lc_suggestible_criteria is empty, this stage can't have suggestions made for it
			if (!mdc.lc_suggestible_criteria || mdc.lc_suggestible_criteria.length == 0) return false
			return true
		},

		stage_currently_suggestible(component) {
			// if we don't have master data for the component, we can't make suggestions
			let mdc = this.master_component(component)
			if (!mdc) return false

			// if we have primary_standards and 'standards' is one of the suggestible criteria, we can make suggestions based on the primary_standards alone
			if (mdc.lc_suggestible_criteria.includes('standards') && this.primary_standards.length > 0) return true

			// if any of the stages listed in this component's lc_suggestible_criteria has content, we can make suggestions based on that content
			for (let stage of mdc.lc_suggestible_criteria) {
				let c = this.lesson_plan.find(x=>x.lc_uuid == stage)
				if (!empty(c?.lc_content)) return true
			}

			// if we get to here, we can't make suggestions
			return false
		},

		stage_status(component) {
			if (component == 'title') return !empty(this.edited_lesson.lesson_title) ? 'complete' : ''
			if (component == 'standards') return this.standards.length > 0 ? 'complete' : ''
			if (component == 'resources') return this.materials_asset_list.length > 0 ? 'complete' : ''
			if (component == 'sparkl') return (this.edited_lesson.sparkl_activity_id != 0) ? 'complete' : ''

			if (typeof(component) == 'string') {
				component = this.lesson_plan.find(x=>x.lc_uuid == component)
			}

			// group header
			if (component.group_header) return 'group-header'
			if (component.group_footer) return 'group-footer'

			return component.lc_status
		},

		// show the hide/show button for a group header...
		show_group_header_hide_show(group_component) {
			// if we haven't started editing at all, don't show
			if (this.is_new_lesson) return false

			// if none of the elements in this group has something already entered, and none have the editor open, don't show
			let group = this.lp_component_scheme.groups.find(x=>x.lc_uuid == group_component.lc_uuid)
			for (let lc_uuid of group.group_components) {
				let lpc = this.lesson_plan.find(x=>x.lc_uuid == lc_uuid) 

				// show components that have been saved, or are open for editing
				if (lpc) {
					if (this.stage_status(lpc) == 'complete' || lpc.lc_open_for_editing) {
						return true
					}
				}
			}

			// if we get to here, don't show
			return false
		},

		show_component_group_btn(component) {
			// if the stage is complete, don't show the button in the group header, because the stage is already showing separately
			if (this.stage_status(component) == 'complete') return false

			// for the 'materials' component, don't show if we have at least one resource showing, because in that case the section will already be showing separately
			if (component == 'materials' && this.materials_asset_list.length > 0) return false

			// if we get to here, show if any of these are true
			return (!this.is_new_lesson || this.standards.length > 0 || this.edit_without_standards)
		},

		section_stage_css(component) {
			let status = this.stage_status(component)
			let mdc = this.master_component(component)
			let s = `k-lpe-alba-content-section-${component.lc_uuid}`

			if (component.group_header) {
				// for lpc_muted_colors (CPS) colors include 'darken-x'; otherwise we have to add lighten-x
				let color = component.color
				if (this.site_config.lpc_muted_colors === 'yes') {
					color += ' white--text'
				} else {
					color += ' lighten-3'
				}

				s += ` k-lpe-alba-section-group ${color}`

			} else if (component.group_footer) {
				// for lpc_muted_colors (CPS) colors include 'darken-x'; otherwise we have to add lighten-x
				let color = component.color
				if (this.site_config.lpc_muted_colors === 'yes') {
					color += ' white--text'
				} else {
					color += ' lighten-4'
				}
				
				s += ` k-lpe-alba-section-group ${color}`

			} else if (!this.component_group_showing(component)) {
				// if the component's group is not showing, don't add any more styles; this hides the component
			} else {
				if (status == 'complete' || (component.lc_uuid == 'materials' && this.materials_asset_list.length > 0)) s += ' k-lpe-alba-section-stage-complete'

				let color = ''
				if (this.site_config.lpc_muted_colors !== 'yes') {
					color = mdc?.lc_color
				}

				if (component?.lc_open_for_editing) s += ` ${color} lighten-5 k-lpe-alba-section-stage-open_for_editing`
				else if (this.last_clicked_component == component) s += ` k-lpe-alba-section-last-clicked ${color} lighten-5`
				else s += ` ${color} lighten-3`
			}
			return s
		},

		section_stage_style(component) {
			let s = ''
			if (this.last_clicked_component == component) s += ''
			else if (!component.group_header && !component.group_footer) s += `background-color:#fff!important`
			return s
		},

		menu_stage_css(component) {
			let status = this.stage_status(component)
			let s = ''
			if (status == 'complete') s += ' k-lpe-alba-menu-stage-complete'
			if (component?.lc_open_for_editing) s += ' k-lpe-alba-menu-stage-open_for_editing'
			return s
		},

		menu_stage_icon(component) {
			let status = this.stage_status(component)
			if (status == 'complete') return 'fas fa-circle-check'
			if (status == 'skipped') return 'fas fa-circle-minus'
			else return 'far fa-circle'
		},

		component_suggestion_html(component, suggestion) {
			return suggestion
			// we may want to format suggestions differently depending on aspects of the component
		},

		open_next_component_for_editing() {
			// if something is already open for editing, just return
			for (let c of this.lesson_plan) {
				if (c.lc_open_for_editing) return
			}

			// if not, open the first non-skipped, non-complete stage for editing
			for (let c of this.lesson_plan) {
				if (empty(c.lc_status)) {
					this.open_stage_for_editing(c)
					return
				}
			}
		},

		stage_done_clicked(component, flag) {
			// for standards...
			if (component == 'standards') {
				// hide satchel
				vapp.$refs.satchel.execute('hide')
				// set standards_done_clicked to true so we don't show the "DONE" btn anymore
				this.standards_done_clicked = true

				this.edited_lesson.standards_showing = false

				// then fall through to open the next (probably the first) stage for editing if flag is 'next'

			// else for other stages...
			} else {
				this.trim_content()
				// if we have content and the user clicked this btn, set status to complete
				if (!empty(component.lc_content)) component.lc_status = 'complete'
				// otherwise status is empty (not complete)
				else component.lc_status = ''

				// either way, lc_open_for_editing is false
				component.lc_open_for_editing = false
			}

			if (flag == 'next') {
				// go through stages in scheme.edit_order
				let current_stage_found
				for (let lc_uuid of this.scheme_edit_order) {
					// wait till we get to the current stage, set current_stage_found to true (standards is a special case)
					if (component?.lc_uuid == lc_uuid) {
						current_stage_found = true
						continue
					}
					// else if current_stage_found (or we were on 'standards'),...
					if (component == 'standards' || current_stage_found) {
						let c = this.lesson_plan.find(x=>x.lc_uuid == lc_uuid)
						// then if this stage isn't yet complete, jump to it
						if (c.lc_status != 'complete') {
							// make sure this stage's group is open
							this.toggle_component_group_showing(null, c, true, false)
							this.open_stage_for_editing(c)
							this.scroll_to_stage(c)
							break
						}
					}
					// else keep going through the stages
				}
			}

			// auto-save
			this.save_lesson('no_spinner')
		},

		toggle_stage_edit(component) {
			// for the standards stage...
			if (component == 'standards') {
				// if standards were showing, call stage_done_clicked
				if (this.edited_lesson.standards_showing) {
					this.stage_done_clicked('standards')
				} else {
					// else show the standards stage
					this.edited_lesson.standards_showing = true
					// set last_edited_component to null so the standards aren't showing anywher else
					this.last_edited_component = null
					// and scroll to the standards
					this.scroll_to_stage('standards')
				}
				return
			}

			if (typeof(component) == 'string') {
				component = this.lesson_plan.find(x=>x.lc_uuid == component)
			}

			// if the stage isn't already open, open it and scroll to stage
			if (!component.lc_open_for_editing) {
				this.open_stage_for_editing(component)
				this.scroll_to_stage(component)
				// make sure the component's group is showing
				this.show_group_for_component(component)
			
			// else do the same thing we would do if the user clicked the 'skip' or 'done' btn
			} else {
				this.stage_done_clicked(component)
			}
		},

		go_to_stage(component) {
			// determine if this stage's group is currently showing -- if the group was hidden, we will show it now
			let group_showing = this.component_group_showing(component)

			// if the group was hidden, always set last_clicked_component to the component
			if (!group_showing) {
				this.last_clicked_component = component

			// else set last_clicked_component to the clicked component, unless the user just clicked on the same component previously (meaning this is is basically toggling on/off)
			} else {
				if (this.last_clicked_component == component) this.last_clicked_component = null
				else this.last_clicked_component = component
			}

			if (component == 'standards') this.edited_lesson.standards_showing = !this.edited_lesson.standards_showing
			else if (component == 'resources') this.edited_lesson.resources_showing = !this.edited_lesson.resources_showing
			else if (component == 'sparkl') this.edited_lesson.sparkl_showing = !this.edited_lesson.sparkl_showing
			else {
				if (typeof(component) == 'string') {
					component = this.lesson_plan.find(x=>x.lc_uuid == component)
				}

				// for all stages with stumpydivs...
				for (let ref of this.$refs.lc_stumpy_div) {
					// if it's the clicked stage,
					if (ref.uuid.search('-' + component.lc_uuid) > -1) {
						// if this stage's group is currently hidden, we always want to show the full text
						if (!group_showing) {
							ref.show_full = true
						} else {
							// else show the full text if we're toggling on; or hide the full text if we're toggling off
							ref.show_full = (this.last_clicked_component == component)
						}
					} else {
						// for all other (non-clicked) stages, hide the full text (unless we're editing??)
						ref.show_full = false
					}
				}
			}

			// make sure the stage's group is showing
			this.show_group_for_component(component)

			// scroll to the stage iff we opened it
			if (this.last_clicked_component == component) this.scroll_to_stage(component)
		},

		open_stage_for_editing(component) {
			component.lc_open_for_editing = true
			this.last_edited_component = component
			this.last_clicked_component = component
			// hide standards section, because we'll be showing the standards in the to-be-edited stage
			this.fast_collapse_standards = true
			this.edited_lesson.standards_showing = false
			setTimeout(x=>{ this.fast_collapse_standards = false }, 1000)
		},

		remove_suggestion(component, index, accepted = false) {
			component.lc_suggestions.splice(index, 1)

			// if first or last array item is '---', remove
			if (component.lc_suggestions[0] == '---') component.lc_suggestions.splice(0, 1)
			if (component.lc_suggestions[component.lc_suggestions.length-1] == '---') component.lc_suggestions.splice(component.lc_suggestions.length-1, 1)
		},

		clear_suggestions(component) {
			while (component.lc_suggestions.length > 0) {
				this.remove_suggestion(component, 0)
			}
		},

		clear_suggestions_debug() {
			// for debugging purposes: totally clear suggestions for the currently-open component
			// vapp.lesson_editor_component.clear_suggestions_debug()
			if (!this.prompt_editor_params?.component) return
			this.prompt_editor_params.component.lc_suggestions = []
			this.prompt_editor_params.component.lc_generated_suggestion_summaries = []
			this.save_lesson('no_spinner')
			setTimeout(x=>window.location.reload(), 1000)
		},

		add_suggestion(component, index) {
			let s = component.lc_suggestions[index]
			this.remove_suggestion(component, index, true)
			let mdc = this.master_component(component)

			// if the component's content is empty before adding, set lc_unaltered_ai to true
			if (empty(component.lc_content)) {
				this.$store.commit('set', [component, 'lc_unaltered_ai', true])
			}

			// for lc_text_format 'list_plain', add a <br> if not currently empty, then add the suggestion
			if (empty(mdc) || mdc.lc_text_format == 'list_plain') {
				// note: we used to do this for 'list' too, but now we explicitly add ul/li tags for lists; see also lessons.js
				if (!empty(component.lc_content)) component.lc_content += '<br>'
				component.lc_content += s
			
			// for lc_text_format 'list', add the suggestion as a bulletted list
			} else if (empty(mdc) || mdc.lc_text_format.includes('list')) {
				component.lc_content += `<ul><li>${s}</li></ul>`
			
			} else if (mdc.lc_text_format == 'paragraphs') {
				// for 'paragraphs' format, add suggestion as a paragraph
				component.lc_content += `<p>${s}</p>`
			
			// else ('line' format), add a <br> if not currently empty, then add the suggestion
			} else {
				if (!empty(component.lc_content)) component.lc_content += '<br>'
				component.lc_content += s
			}

			this.update_froala_value(component)

			// add to lesson gpt stats
			this.edited_lesson.gpt_suggestion_accepts += 1

			this.save_lesson('no_spinner')
		},

		/*
		remove_model_suggestion(component, index) {
			component.lc_model_suggestions.splice(index, 1)
		},

		add_model_suggestion(component, index) {
			let s = component.lc_model_suggestions[index]
			this.remove_model_suggestion(component, index)
			// note that here we replace any previously-entered model response with the selected suggestion
			component.lc_sparkl_model_response = s

			this.update_froala_value(component, 'cr_model')

			// add to lesson gpt stats
			this.edited_lesson.gpt_suggestion_accepts += 1

			this.save_lesson('no_spinner')
		},
		*/

		trim_content() {
			for (let component of this.lesson_plan) {
				let s = component.lc_content
				if (empty(s)) continue

				// console.log(`before trim: “${s}”`)
				s = s.replace(/\s*(<\/p>)/g, '$1')		// trim spaces before the ends of paragraphs
				s = s.replace(/(<p>)\s*/g, '$1')		// trim spaces at the starts of paragraphs
				s = s.replace(/<p>\s*<\/p>/g, '')		// remove empty paragraphs

				// remove blank lines after hr's
				s = s.replace(/(<hr>)\s*<p[^>]*>(\s*<br>\s*)<\/p>/g, '$1')

				s = s.replace(/\s*(<br>)/g, '$1')		// trim spaces before line breaks
				s = s.replace(/(<br>)\s*/g, '$1')		// trim spaces after line breaks
				s = s.replace(/(<br>)+/g, '<br>')		// reduce two or more line breaks to a single line break
				s = s.replace(/<br>+$/g, '')			// remove line breaks at the end of the content

				s = $.trim(s)

				component.lc_content = s
			}
		},

		message_text(base, component, mdc) {
			// this is for filling in the current content of the component
			let s = base.replace(/\$format_for_gpt_message/g, U.html_to_text_with_spacing(component.lc_content))

			s = s.replace(/\$suggestions_to_request/g, this.suggestions_to_request)

			for (let key in mdc) {
				// this is for filling in strings (e.g. lc_title) of the *master component*
				let re = new RegExp('\\$' + key, 'g')
				s = s.replace(re, mdc[key])
			}
			s = s.replace(/<(p|div|span|li).*?>/g, '')
			s = s.replace(/<\/(p|div|span|li).*?>/g, ' ')
			return U.html_to_text(s)
		},

		sparkl_include_help_text(s) {
			s = s.replace(/\$sparkl_app_name\b/g, this.site_config.sparkl_app_name)
			return s
		},

		/*
		// no longer used; we would need to update the formatting of the message to use it in the future
		make_response_suggestion(component) {
			// if we don't have a master component for this component, we can't make suggestions (this might happen if the lesson was imported from another system...)
			let mdc = this.master_component(component)
			if (!mdc || empty(mdc.lc_gpt_model_prompt)) {
				this.$alert('Model response suggestions cannot be made for this lesson component.')
				return false
			}

			// trim all content; then if this stage doesn't have content, return (this shouldn't happen)
			this.trim_content()
			if (empty(component.lc_content)) return

			// system: You are a laconic assistant. You reply with brief, to-the-point answers. You do not repeat user questions in your answers.
			// system: You are a helpful assistant that does not repeat user questions in your answers.

			// message is lc_gpt_model_prompt with substitutions; start with standard message_text substitutions
			let messages = this.message_text(mdc.lc_gpt_model_prompt, component, mdc)

			// compose grade_phrase based on primary_standards if we have them
			let grade_phrase = ''
			let grade_low = 100
			let grade_high = -10
			if (this.primary_standards.length > 0) {
				for (let i = 0; i < this.primary_standards.length; ++i) {
					let s = this.primary_standards[i]
					if (U.grade_value(s.grade_low) < grade_low) grade_low = U.grade_value(s.grade_low)
					if (U.grade_value(s.grade_high) > grade_high) grade_high = U.grade_value(s.grade_high)
				}
			}
			grade_low = vapp.$store.state.grades[grade_low]		// todo: spell out "pre-kindergarten" and "kindergarten"
			grade_high = vapp.$store.state.grades[grade_high]
			if (grade_low || grade_high) {
				if (grade_low == grade_high) grade_phrase = 'in Grade ' + grade_low
				else grade_phrase = `in Grades ${grade_low} to ${grade_high}`
			}
			// replace grade_phrase (this will be an empty string if we don't have primary_standards)
			messages = messages.replace(/\$grade_phrase/, grade_phrase)

			// console.log(messages)
			// return

			// call the gpt function, then add resulting suggestions to the component's lc_model_suggestions
			this.gpt_start({messages: messages}).then(responses=>{
				console.log(responses)
				component.lc_model_suggestions.push(responses[0])

				// save, so that we have the suggestions if the user leaves and comes back later
				this.save_lesson('no_spinner')
			})
		},
		*/

		make_component_suggestions(component, prompt_addition) {
			// if we don't have a master component for this component, we can't make suggestions (this might happen if the lesson was imported from another system...)
			let mdc = this.master_component(component)
			if (!mdc) {
				this.$alert('Suggestions cannot be made for this lesson component.')
				return false
			}

			// trim all content; then if this stage isn't actually suggestible (i.e. because we don't have anything to base suggestions on), show an appropriate alert
			this.trim_content()
			if (!this.stage_currently_suggestible(component)) {
				this.$alert(this.message_text(mdc.lc_not_suggestible_msg, component, mdc))
				return
			}

			// set prompt_editor_params to show the UI where the teacher can modify the prompt if they wish
			this.prompt_editor_params = {
				component: component,
				mdc: mdc,
			}
		},
		
		async make_component_suggestions2(component, messages) {
			// close the prompt editor dialog
			this.prompt_editor_params = null

			let mdc = this.master_component(component)

			let schema
			if (component.lc_uuid == 'vocabulary') {
				schema = object_copy(this.vocab_schema)
			} else {
				schema = object_copy(this.default_schema)
				if (component.lc_suggestion_length > 0) {
					// ChatGPT says that a range is better than "approximately X"
					let min = Math.floor(component.lc_suggestion_length * 0.85)
					let max = Math.ceil(component.lc_suggestion_length * 1.15)
					schema.properties.output.items.properties.suggestion_text.description += ` Each suggestion should be ${min}-${max} words long, and all suggestions should be approximately the same length.`
				} else {
					schema.properties.output.items.properties.suggestion_text.description += ` All suggestions should be approximately the same length.`
				} 
			}
			// console.log(schema)

			// if we have a list of site_config.lpc_stop_words, remove them from the prompt (messages) before sending
			messages = U.remove_stop_words(messages, this.site_config.lpc_stop_words)

			// call the gpt function, then add resulting suggestions to the component
			let payload = {
				user_id: this.user_info.user_id,
				model: this.gpt_model,
				input: messages,
				format: JSON.stringify({
					type: 'json_schema',
					name: component.lc_uuid,
					strict: true,
					schema: schema,
				})
			}

			U.loading_start('<i class="fas fa-robot white--text"></i> Asking LLM for suggestions')
			let ajax_result = await U.ajax_promise('openai_query', payload)
			U.loading_stop()
			if (ajax_result.status != 'ok') {
				console.error(ajax_result)
				this.$alert('An error occurred when attempting to generate the LLM suggestion.')
				return false
			}
			console.log('ajax_result:', ajax_result)
			let responses = ajax_result.response

			this.edited_lesson.gpt_suggestion_requests += 1
			this.edited_lesson.gpt_input_tokens += ajax_result.full_response[0].usage.input_tokens
			this.edited_lesson.gpt_output_tokens += ajax_result.full_response[0].usage.output_tokens

			component.lc_suggestions.push('---')
			let sum_words = 0
			let n = 0
			for (let response of responses) {
				++n
				if (component.lc_uuid == 'vocabulary') {
					// if we have a list of site_config.lpc_stop_words, remove them from the response
					response.term = U.remove_stop_words(response.term, this.site_config.lpc_stop_words)
					response.definition = U.remove_stop_words(response.definition, this.site_config.lpc_stop_words)
					
					sum_words += U.word_count(response.definition)

					// add term to component.lc_generated_suggestion_summaries
					component.lc_generated_suggestion_summaries.push(response.term)

					response = `<b data-summary="true">${response.term}</b>: <span data-suggestion="true">${response.definition}</span>`

				} else {
					// if we have a list of site_config.lpc_stop_words, remove them from the response
					response.summary = U.remove_stop_words(response.summary, this.site_config.lpc_stop_words)
					response.suggestion_text = U.remove_stop_words(response.suggestion_text, this.site_config.lpc_stop_words)

					sum_words += U.word_count(response.suggestion_text)

					// add summary to component.lc_generated_suggestion_summaries
					component.lc_generated_suggestion_summaries.push(response.summary)

					// for some sections (e.g. opening/closing question), just add the suggestion, not the summary (but we save the summary for if we ask for different items later)
					if (mdc.lc_no_summary_in_suggestion == true) {
						response = `<span data-suggestion="true">${response.suggestion_text}</span>`
					} else {
						response = `<b data-summary="true">${response.summary}</b>: <span data-suggestion="true">${response.suggestion_text}</span>`
					}
				}
				setTimeout(x=>component.lc_suggestions.push(response), n * 250)
			}
			// record lc_suggestion_length
			component.lc_suggestion_length = Math.round(sum_words / responses.length)

			// save, so that we have the suggestions if the user leaves and comes back later
			setTimeout(x=>this.save_lesson('no_spinner'), (n * 250 + 50))
		},

		////////////////////////////////////////////
		open_lesson_sparkl_creator() {
			if (this.edited_lesson.lesson_id == 0) {
				this.$alert('You must save the lesson before creating a lesson activity.')
				return
			}

			// when the user clicks the update lesson activity btn, if we already have a lesson activity and we don't have a resource for it, immediately save the resource 
			// (this should only happen for LPC lessons created prior to 1/2025)
			if (this.edited_lesson.sparkl_activity_id != 0 && this.edited_lesson.resources.findIndex(x=>x.url == this.edited_lesson.sparkl_activity_id) == -1) {
				console.warn('CREATE SPARKL RESOURCE for', this.edited_lesson.sparkl_activity_id)
				this.save_new_lesson_sparkl_resource(this.edited_lesson.lesson_title, false)
			}
			this.sparkl_creator_open = true
		},

		// create a sparkl activity accompanying the lesson
		create_lesson_sparkl_activity() {
			/////////////////////////
			// establish the base activity data
			let activity_data = {
				title: `Lesson Activity: ${this.edited_lesson.lesson_title}`,
				editors: `,${this.user_info.email},`,
				activity_instructions: '',
				exercises: [],
				// set completion_mode to off
				completion_mode: 'no',
				// set allow_retry to on
				allow_retry: 'yes',
				// set 'open-door' policy to off
			    student_access_policy: 'signed_in',	// 'no_sign_in'
				// display settings
				default_activity_display_settings: {
					sound_effects: 'subtle',	// 'on', 'off'
					colors: 'more',	// 'less'
					sparkl_bot: 'on',	// 'off'
				},
				stars_available: 0,

				case_alignments: [],
			}
			// copy standards alignments using sparkl format
			for (let s of this.standards) {
				activity_data.case_alignments.push(s.convert_to_sparkl_format())
			}

			let exercises_data = []

			/////////////////////////
			// add an exercise (or student instructions) for each included lesson component
			for (let component of this.lesson_plan) {
				if (!component.lc_include_in_sparkl) continue

				let mdc = this.master_component(component)
				if (!mdc) continue

				let exercise_data = {
					exercise_id: component.lc_sparkl_exercise_id ? component.lc_sparkl_exercise_id : U.new_uuid(),
					exercise_title: mdc.lc_title,
					exercise_type: 'freeform',
					body: '',
					parts: [],
					queries: {},
					stars_available: 0,
				}

				// create sparkl exercise template based on lc_content and lc_sparkl_include_method

				// ============== STUDENT INSTRUCTIONS
				if (mdc.lc_sparkl_include_method == 'student_instructions') {
					activity_data.activity_instructions += `${mdc.lc_title_plural}:`
					activity_data.activity_instructions += this.section_text(component)
					
				// ============== BASIC FREEFORM EXERCISE
				} else if (mdc.lc_sparkl_include_method == 'basic_content') {
					let bc_query = new Basic_Content_Query({
						uuid: component.lc_sparkl_query_ids[0],	// this could be empty
						part_index: 0,
						stars_available: 1,
						permanent: false,
					})
					component.lc_sparkl_query_ids[0] = bc_query.uuid	// save query uuid so we re-use the same one later
					exercise_data.queries[bc_query.uuid] = bc_query

					// content can be supplied in lesson master; if not use section_text
					if (mdc.lc_sparkl_placeholder_text) exercise_data.body = mdc.lc_sparkl_placeholder_text
					else exercise_data.body = this.section_text(component)
					
					exercise_data.parts.push({
						part_type: 'basic_content',
						interactive_reading: 'off',
					})
					exercise_data.stars_available = 1

				// ============== SCAFFOLDED RESPONSE EXERCISE
				} else if (mdc.lc_sparkl_include_method == 'scaffolded_response') {
					let bc_query = new Basic_Content_Query({
						uuid: component.lc_sparkl_query_ids[0],	// this could be empty
						part_index: 0,
						stars_available: 1,
						permanent: false,
					})
					component.lc_sparkl_query_ids[0] = bc_query.uuid	// save query uuid so we re-use the same one later
					exercise_data.queries[bc_query.uuid] = bc_query

					// content can be supplied in lesson master; if not use section_text
					if (mdc.lc_sparkl_placeholder_text) exercise_data.body = mdc.lc_sparkl_placeholder_text
					else exercise_data.body = this.section_text(component)
					
					exercise_data.parts.push({
						part_type: 'scaffolded_response',
						interactive_reading: 'off',
						part_prompt: '',
					})
					exercise_data.stars_available = 1

				// ============== IR EXERCISE
				} else if (mdc.lc_sparkl_include_method == 'interactive_reading') {
					// create the ir query
					let ir_query = new Interactive_Reading_Query({
						uuid: component.lc_sparkl_query_ids[0],	// this could be empty
						part_index: 0,
					})
					component.lc_sparkl_query_ids[0] = ir_query.uuid	// save query uuid so we re-use the same one later
					exercise_data.queries[ir_query.uuid] = ir_query

					// content can be supplied in lesson master; if not use section_text
					if (mdc.lc_sparkl_placeholder_text) exercise_data.body = mdc.lc_sparkl_placeholder_text
					else exercise_data.body = this.section_text(component)

					// calculate number of words for auto-blanks
					let num_blanks = 0
					let blankable_words = U.auto_blank_process_html(exercise_data.body)
					if (blankable_words.length > 0) {
						num_blanks = U.auto_blank_num_blanks(blankable_words.length, 'fewer')
					}

					// create one query per auto-blank
					for (let i = 0; i < num_blanks; ++i) {
						let query = new window.Hangman_Query({
							uuid: component.lc_sparkl_query_ids[i+1],	// this could be empty
							blank_letters: 1,
							stars_per_letter: 1,
							part_index: 0,
							correct_answer:'AUTO',
							auto_blank: true,
							stars_available: 1,
						})
						component.lc_sparkl_query_ids[i+1] = query.uuid	// save query uuid so we re-use the same one later
						exercise_data.queries[query.uuid] = query
					}

					exercise_data.parts.push({
						part_type: 'interactive_reading',
						interactive_reading: 'on',
						auto_blanks: 'on',
						ab_count: 'fewer',
						ab_letters: '1',
					})
					exercise_data.stars_available = num_blanks
				
				// ============== CR EXERCISE
				} else if (mdc.lc_sparkl_include_method == 'cr_query') {
					let cr_query = new CR_Query({
						uuid: component.lc_sparkl_query_ids[0],	// this could be empty
						part_index: 0,
						prompt: component.lc_content,
						model_response: component.lc_sparkl_model_response,
						answer_type: 'text',
						version: 1,	// this is crucial; if not set, the CR might be accidentally deleted if edited but not changed
						stars_available: 8,
					})
					component.lc_sparkl_query_ids[0] = cr_query.uuid	// save query uuid so we re-use the same one later
					exercise_data.queries[cr_query.uuid] = cr_query
					exercise_data.body += `<p>[[${cr_query.uuid}]]</p>`
					exercise_data.parts.push({
						part_type: 'cr',
						interactive_reading: 'off',
					})
					exercise_data.stars_available = 8

				// ============== FLASHCARDS EXERCISE
				} else if (mdc.lc_sparkl_include_method == 'flashcards') {
					exercise_data.exercise_type = 'flashcards'
					exercise_data.required_mode = 'browse'

					let lines = component.lc_content.split('<br>')
					for (let i = 0; i < lines.length; ++i) {
						let arr = U.html_to_text(lines[i]).match(/^\s*(.*)\s*[:-]\s*(.*)\s*$/)
						if (!arr) {
							console.warn('bad flashcard line: ' + lines[i])
							continue
						}
						let query = new Flashcard_Query({
							uuid: component.lc_sparkl_query_ids[i],	// this could be empty
							part_index: -1,
							stars_available: 1,
							term: arr[1],
							definition: arr[2],
						}, {required_mode: 'browse'})
						component.lc_sparkl_query_ids[0] = query.uuid	// save query uuid so we re-use the same one later
						exercise_data.queries[query.uuid] = query
						exercise_data.stars_available += 1
					}
				}

				// Add exercise to activity if we created one
				if (mdc.lc_sparkl_include_method != 'student_instructions') {
					exercises_data.push(exercise_data)
					activity_data.exercises.push({exercise_id: exercise_data.exercise_id})
					activity_data.stars_available += exercise_data.stars_available

					// also save exercise_id to component
					component.lc_sparkl_exercise_id = exercise_data.exercise_id
				}
			}

			/////////////////////////
			// save, or update, the activity
			let activity_is_new = (this.edited_lesson.sparkl_activity_id == 0)

			// if we already have an activity_id, send it through too, so we update the existing activity
			if (!activity_is_new) activity_data.activity_id = this.edited_lesson.sparkl_activity_id

			let sparkl_activities = [{activity_data: activity_data, exercises_data: exercises_data}]
			console.log(`saving activity “${activity_data.title}”`, sparkl_activities)

			// stringify the activities, and put it through encode_blocked_keywords so firewalls won't reject it
			// note though, that we don't send the encode_blocked_keywords flag through to the *cureum* server; rather the cureum service sends the encode_blocked_keywords through to the *sparkl* server
			// we also do an "extra round" of encoding here using btoa on the client side, because on 9/5/2025 this service was getting rejected without it
			let bytes = new TextEncoder().encode(U.encode_blocked_keywords(JSON.stringify(sparkl_activities)))
			let activities_string = btoa(String.fromCharCode(...bytes))

			let payload = {
				user_id: this.user_info.user_id, 
				sparkl_activities: activities_string,
				editor_email: this.user_info.email,
				update_or_overwrite: 'update',
			}
			if (this.sparkl_origin_override) payload.sparkl_origin_override = this.sparkl_origin_override

			U.loading_start()
			U.ajax('bulk_create_sparkl_activity', payload, result=>{
				U.loading_stop()
				console.log('bulk_create_sparkl_activity', result)

				if ((result?.status ?? '') != 'ok') {
					this.$alert('Error creating or updating activity.')
				} else {
					// let msg = (this.edited_lesson.sparkl_activity_id == 0) ? 'Activity created' : 'Activity updated'
					// this.$inform(msg)
					this.flash_save_indicator()

					// we should get the activity_id in the result as follows:
					this.edited_lesson.sparkl_activity_id = result.sparkl_rv.activity_ids[0]

					this.save_lesson('no_spinner')

					// force the sparkl activity to reload the next time we open it (might be now, might be later)
					vapp.$refs.sparkl_embed.force_reload_when_reopened()

					// now that we've created the activity, if it is new, create a corresponding resource, then open it
					if (activity_is_new) this.save_new_lesson_sparkl_resource(activity_data.title, true)

					// If you're in a course collection, you can then assign the resource to your students by clicking on it
				}
			})
		},

		// create a resource for the lesson sparkl activity, linked to the lesson and also mapped to the user's default collection
		save_new_lesson_sparkl_resource(activity_title, open_new_activity) {
			// make sure we have access to the default collection (we should)
			let dc = this.$store.getters.my_default_collection
			if (empty(dc?.units[1]?.resources?.length)) {
				this.$alert('Error: can’t save activity resource (323)')
				return
			}

			let r = new Resource({
				resource_id: 'new',
				// If the lesson is agency sanctioned, the resource should be agency_sanctioned too... but really, the agency shouldn't be making an activity here;
				// we should really disallow the create activity for agency-sanctioned lessons
				agency_sanctioned: this.edited_lesson.agency_sanctioned,
				publish_status: this.edited_lesson.agency_sanctioned ? 'published' : null,
				description: activity_title,
				teacher_facing: false,
				type: 'sparkl',
				url: this.edited_lesson.sparkl_activity_id,
				creator: this.user_info.user_id,
			})
			this.$store.dispatch('save_resource', {resource: r}).then((resource_data)=>{
				// once resource is saved...
				let r = new Resource(resource_data)

				// add the resource to the user's sandbox -- push to default_collection, unit 1.resources, then call the save_default_collection_resources service (see CollectionUnit)
				dc.units[1].resources.push(r)
				this.$store.dispatch('save_default_collection_resources').then(() => {
					console.warn('save_default_collection_resources done')
				})

				// then add the resource to the lesson and save the lesson
				this.edited_lesson.resources.push(r)
				this.save_lesson('no_spinner')

				// and, after some time to let it appear, use the ResourceCollectionItem to open the activity (if open_new_activity is true)
				if (open_new_activity) setTimeout(x=>this.open_lesson_sparkl_activity(), 1000)

			}).catch(error=>{
				console.log(error)
				this.$alert(sr('A problem occurred when attempting to save the resource. Message from server:<div class="mt-2">$1</div>', error))
			})

		},

		//////////////////////////////////////////////////////////////
		check_for_new_resources() {
			// get array of all convertible links across all components
			let convertible_links = []
			for (let component of this.lesson_plan) {
				// note that we use the same regex below
				let matches = component.lc_content.matchAll(/<a .*?>([\s\S]*?)<\/a>/g)
				for (let arr of matches) {
					let jq = $(arr[0])
					let link_text = jq.text().trim()

					// skip empty links
					if (empty(link_text)) continue

					let url = jq.attr('href')

					let o = convertible_links.find(x=>x.url == url)
					if (o) o.count += 1
					else convertible_links.push({
						link_text: link_text,
						url: url,
						type: Resource.guess_resource_type_from_url(url),
						count: 1,
						to_convert: false,
						already_resource: false,
						converted: false,
					})
				}
			}
			console.log(convertible_links)

			if (convertible_links.length == 0) {
				this.$alert('There were no links available to be converted.')
				return
			}

			this.$confirm({
				title: 'Convert Links to Resources',
				text: `Click CONVERT<i class="fas fa-arrow-right mr-1"></i> to process the <b>${convertible_links.length}</b> convertible links found in the Lesson. Notes:<ul><li>If any of these links are already saved as resources in ${this.site_config.app_name}, the existing resources will be used (that is, new resources/resource IDs will not be created).</li><li>After converting the links to resources, you will be free to edit any properties of the resources (e.g. resource type, description, or standards alignments).</li></ul>`,
				acceptText: 'Convert',
				acceptIconAfter: 'fas fa-arrow-right',
				dialogMaxWidth: 680,
			}).then(y => {
				this.convert_links_to_resources(convertible_links, 0)
			}).catch(n=>{console.log(n)}).finally(f=>{})
		},

		convert_links_to_resources(convertible_links, index) {
			// for (let link of convertible_links) {
			let link = convertible_links[index]

			// TODO: the resource might already be present in the lesson; if so we don't have to save it here
			let resource = new Resource({
				resource_id: 'import',	// this will trigger save_resource to return the existing resource if it already exists, or create a new one otherwise
				teacher_facing: true,
				type: link.type, 
				url: link.url, 
				description:link.link_text
			})

			// save the resource
			this.$store.dispatch('save_resource', {resource: resource}).then((resource_data)=>{
				// create a new Resource object from the returned resource_data, which will include the resource_id (and might include standards if it was an existing resource)
				let saved_resource = new Resource(resource_data)

				// add to lesson resources, unless it's already there (it shouldn't be)
				if (!this.edited_lesson.resources.find(x=>x.resource_id == saved_resource.resource_id)) {
					this.edited_lesson.resources.push(saved_resource)
				}

				// do the regex replaces in the component content
				this.convert_link_text_to_resources_in_lc_content(saved_resource)

				// if this wasn't the last resource, do the next one
				if (index != convertible_links.length-1) {
					this.convert_links_to_resources(convertible_links, index+1)
				} else {
					this.$alert('Conversion complete! Remember to save your Lesson if you’re happy with the changes.')
				}

			}).catch(error=>{
				console.log(error)
				this.$alert(`A problem occurred when attempting to save the resource. Message from server:<div class="mt-2">${error}</div>`)
			})
		},

		convert_link_text_to_resources_in_lc_content(resource) {
			for (let component of this.lesson_plan) {
				let changed = false
				// same regex as above
				component.lc_content = component.lc_content.replace(/<a .*?>([\s\S]*?)<\/a>/g, ($0, $1) => {
					// remove empty links
					if (empty($1.trim())) {
						changed = true
						return ''
					}

					let href = $($0).attr('href')
					// if this link matches the resource's url, replace the link with the link text plus the resource link icon
					if (href == resource.url) {
						// console.log(`FOUND IT! ${resource.description}`)
						changed = true
						return `${$1}${resource.froala_resource_link_html()}`
					}

					// if we get to here, no change
					return $0
				})

				// update the froala value if it was changed
				if (changed) this.update_froala_value(component)
			}
		},

		lc_option_select_changed(component) {
			if (component.lc_content == 'Other') {
				component.lc_option_other_chosen = true
				component.lc_content = ''
			} else {
				component.lc_option_other_chosen = false
			}
		},

		lp_component_scheme_changed() {
			console.warn('change to ' + this.edited_lesson.lp_component_scheme)
			this.edited_lesson = new Lesson(this.edited_lesson, this.lesson_master)
		},

		//////////////////////////////////////////////////////////////
		give_feedback() {
			let issue_params = {
				item: this.edited_lesson,
			}
			vapp.report_issue(issue_params)
		},
	}
}
</script>

<style lang="scss">
// this class, or something like it, should be applied on the div that includes the LessonEditor component
.k-lpe-lesson-edit-outer {
	position:relative;
	// margin-top:8px;
	// padding:16px 8px;
	// background-color:#eee;
	// border-radius:8px;
}

.k-lpe-lesson-edit {
	.v-input {
		font-size:15px;
	}

	.k-lp-editor-standard-resource {
		padding:5px;
		margin:10px 0;
		border-radius:4px;
		background-color:#eee;
	}

	.k-lp-editor-standard-description {
		flex:1 1 auto;
		cursor:pointer;
		font-size:14px;
		line-height:18px;
	}
}

.k-lpe-lesson-editor-buttons {
	// border-top:1px solid #999;
	background-color:#eee;
	position:absolute;
	left:0;
	bottom:0px;
	border-radius:0 0 8px 8px;
	width:100%;
	display:flex;
	align-items:center;
	z-index:1001;
}

.v-dialog .k-lpe-lesson-editor-buttons {
	background-color:#fff;
	margin-bottom:-8px;
	padding-bottom:8px;
}

// this fixes things so that the "full screen" button shows up properly, at least in the lesson editor
.fr-toolbar .fr-expanded {
	width:calc(100% + 1px)!important;
	margin-left:-1px;
}

.k-lpe-editor-dialog {
	max-height:calc(100vh - 20px)!important;
}

///////////////////////////////////////////////////////////////
.k-lpe-alba-outer-outer {
	display:flex;
	// max-height:560px;
	// margin-top:8px;
	// max-height:calc(100vh - 116px);	// this works with .k-lpe-editor-dialog
	max-height:calc(100vh - 124px);	// this works with .k-lpe-editor-dialog
	border:1px solid #999;
	// border-radius:10px 0 0 10px;
}

.k-lpe-alba-menu-stages {
	flex: 0 0 268px;
	// background-color:#ddd;
	font-size:16px;
	// border-right:1px solid #999;
	// margin-right:-1px;
	display:flex;
	flex-direction:column;
	overflow-x:hidden;
	overflow-y:auto;
	// border-radius:9px 0 0 9px;

	.k-lpe-alba-menu-stage-outer {
		flex: 0 1 auto;
		border-bottom:1px solid #999!important;
		border-right:1px solid #999!important;
		opacity:0.7;
		background-color:#fff;
		// display:flex;
	}
	.k-lpe-alba-menu-stage {
		cursor:pointer;
		padding:8px;
		// font-weight:bold;
		font-size:15px;
		color:#000;
		display:flex;
		.fas, .far { margin-top:-3px; font-size:20px!important; opacity:0.5; }
		.fas.fa-circle-check, .far.fa-circle { color:#222!important; }

		.k-lpe-alba-menu-stage-label {
			flex: 1 1 auto;
		}
	}

	.k-lpe-alba-menu-stage-hovered .k-lpe-alba-menu-stage {
		// text-shadow:0 0 1px #999;
	}

	.k-lpe-alba-menu-stage-available { 
		opacity:1;
		.fas, .far { opacity:1; }
	}
	.k-lpe-alba-menu-stage-open_for_editing {
		opacity:1;
		.fas, .far { opacity:1; }
		font-weight:bold;
	}
	.k-lpe-alba-menu-stage-complete { 
		opacity:1; 
		color:#000;
		.fas, .far { opacity:1; }
		font-weight:bold;
	}
}

.k-lpe-alba-menu-stages, .k-lpe-alba-content {
	background-color:#eee;
}


.k-lpe-alba-content {
	flex: 1 1 auto;
	// border-left:1px solid #999;
	display:flex;
	flex-direction:column;
	// background-color:#eee;
	// border-radius:0 9px 9px 0;

	.k-lpe-alba-content-inner {
		flex:1;
		overflow:auto;
		// padding:0px 12px 8px 12px;
		// padding:0 0 8px 0;

	}

	.k-lpe-alba-content-section {
		display:none;
		border:1px solid #ccc;
		border-radius:10px;
		padding:8px 16px 8px 16px;
		// margin:0 2px -1px 2px;
		margin:4px 4px 4px 8px;
		box-shadow:0px 0px 2px #666;
		background-color:#fff;
		// margin-top:-5px;

		.k-stumpy-div-inner-wrapper {
			background-color:#fff;
			border-radius:6px;
		}
	}

	.k-lpe-alba-section-header-icon {
		font-size:24px!important;
		width:24px;
		margin:2px 8px 0 0px;
		padding:0;
	}

	.k-lpe-alba-section-header-text {
		white-space:nowrap;
		font-weight:bold;
		// margin-left:4px;
		cursor:pointer;
	}

	// this is used for the actual text of a section
	.k-lpe-alba-section-summary {
		padding:0px 8px;
		margin-top:8px;
		// border-radius:4px;
		// flex: 0 1 600px;
		// max-width:600px;
	}

	// other attributes we store on resource links (as of 5/3/2026): data-resource-type, data-teacher-facing
	// Note: resource colors are customizable for each cureum instance, so we can't code them with css here
	.k-lpe-alba-section-summary:not(.k-lesson-resource-collection), .k-lpe-alba-section-editor {
		a:not(.k-lesson-component-resource-anchor-link) { 
			text-decoration: underline 2px $v-blue-accent-4!important; 
		}
	}

	.k-lpe-alba-section-summary-empty {
		text-align:center;
		font-size:14px;
		font-style:italic;
	}

	.k-lpe-alba-section-instructions {
		display:none;
		background-color:#f8f8f8;
		padding:0px 8px;
		border-radius:4px;
		// flex: 0 1 600px;
		font-size:14px;
		line-height:18px;
		margin-left:12px;
	}

	.k-lpe-alba-section-view-guidance {
		background-color:#eee;
		padding:4px 8px;
		border-radius:4px;
		// flex: 0 1 600px;
		font-size:14px;
		line-height:18px;
		margin-left:12px;
	}

	.k-lpe-alba-section-editor {
		// display:none;
	}

	.k-lpe-alba-section-buttons {
		display:flex;
		align-items:center;
		margin-top:8px;
		margin-bottom:8px;
	}

	.k-lpe-alba-section-stage-open_for_editing { 
		display:block;
		.k-lpe-alba-section-instructions { display:block; }
		// .k-lpe-alba-section-editor { display:block; }
		.k-lpe-alba-section-summary, .k-lpe-alba-section-summary-wrapper, .k-lpe-alba-section-resources { display:none; }
	}
	.k-lpe-alba-section-stage-marked_done { 
	}
	.k-lpe-alba-section-stage-complete { 
		display:block;
	}

	.k-lpe-alba-content-section.k-lpe-alba-section-stage-open_for_editing {
		// border-bottom-width:3px;
		// background-color:#eee;
		// border-bottom:3px solid #000!important;
		// border-top:3px solid #000!important;
		border:3px solid #000!important;
		// margin-top:-3px;
	}

	.k-lpe-alba-section-last-clicked {
		.k-lpe-alba-section-summary-wrapper {
			margin-top:8px;
		}
	}

	.k-lpe-alba-section-group {
		display:block;
	}

	.k-lpe-menu_stage_btn {
		// .fas, .far { margin-top:-3px; font-size:20px!important; opacity:0.5; }
		.fas.fa-circle-check, .far.fa-circle { 
			font-size:20px!important; 
			// color:#222!important; 
		}
	}
	.k-lpe-menu_stage_btn.v-btn--outlined {
		background-color:#fff;
	}

	// .k-lpe-alba-content-section:first-child { border-top:0; padding-top:0; }
}

// make links stand out in section text
a.k-lesson-component-resource-anchor-link {
	background-color:#444;
	color:#fff!important;
	padding:3px 6px;
	border-radius:4px;
	text-decoration:none;
}
a.k-lesson-component-resource-anchor-link::before {
	font-family:"Font Awesome 6 Pro";
	font-size:0.9em;
	font-weight:bold;
	// line-height:2px;
	margin-right:4px;
	content:"\f0c1";	// link
}

a.k-lesson-component-resource-anchor-link[data-resource-icon="fa-file-lines"]::before { content:"\f15c" }
a.k-lesson-component-resource-anchor-link[data-resource-icon="fa-images"]::before { content:"\f302" }
a.k-lesson-component-resource-anchor-link[data-resource-icon="fa-table"]::before { content:"\f0ce" }
a.k-lesson-component-resource-anchor-link[data-resource-icon="fa-file"]::before { content:"\f15b" }
a.k-lesson-component-resource-anchor-link[data-resource-icon="fa-file-pdf"]::before { content:"\f1c1" }
a.k-lesson-component-resource-anchor-link[data-resource-icon="fa-file-image"]::before { content:"\f1c5" }
a.k-lesson-component-resource-anchor-link[data-resource-icon="fa-file-word"]::before { content:"\f1c2" }
a.k-lesson-component-resource-anchor-link[data-resource-icon="fa-file-powerpoint"]::before { content:"\f1c4" }
a.k-lesson-component-resource-anchor-link[data-resource-icon="fa-link"]::before { content:"\f0c1" }
a.k-lesson-component-resource-anchor-link[data-resource-icon="fa-clipboard-list"]::before { content:"\f46d" }
a.k-lesson-component-resource-anchor-link[data-resource-icon="fa-video"]::before { content:"\f03d" }
a.k-lesson-component-resource-anchor-link[data-resource-icon="fa-star"]::before { content:"\f005" }
a.k-lesson-component-resource-anchor-link[data-resource-icon="fa-building-columns"]::before { content:"\f19c" }
a.k-lesson-component-resource-anchor-link[data-resource-icon="fa-file-alt"]::before { content:"\f15c" }
a.k-lesson-component-resource-anchor-link[data-resource-icon="fa-chalkboard"]::before { content:"\f51b" }
a.k-lesson-component-resource-anchor-link[data-resource-icon="fa-folder"]::before { content:"\f07b" }


// .v-application .green.lighten-5.k-lpe-alba-content-section {
// 		border-color: #ccc!important;
// }

.k-lpe-alba-content-item {
	display:flex;
	align-items:flex-start;
	margin-left:-4px;
	padding-left:4px;
	border-radius:5px;
}

.k-lpe-alba-textarea textarea {
	font-size: 14px;
    line-height: 18px;
}

.k-lpe-alba-saved-indicator {
	background-color:$v-green-darken-3;
	color:#fff;
	font-weight:bold;
	font-size:18px;
	line-height:18px;
	padding:3px 8px;
	border-radius:8px;
	border:4px solid $v-amber-accent-4;
	transition:all 0.2s;
	box-shadow: 0 0 10px rgba(255, 230, 0, 0.8), 0 0 20px rgba(255, 230, 0, 0.6);
}

.k-lpe-dog-icon {
	font-size:1.15em!important;
	animation: lpe-dog-icon-hop 5s infinite;
	color:$v-brown-darken-2!important;
}

@keyframes lpe-dog-icon-hop {
	0% { transform: translateY(0px) scaleX(-1);}
	3% { transform: translateY(-3px) rotate(10deg) scaleX(-1);}
	6% { transform: translateY(0px) scaleX(-1);}
	9% { transform: translateY(0px) scaleX(-1);}
	12% { transform: translateY(-3px) rotate(-10deg) scaleX(-1);}
	15% { transform: translateY(0px) scaleX(-1);}
	100% { transform: translateY(0px) scaleX(-1);}
}

.k-collapse-fast.expand-transition-leave-active {
  transition-duration: 0ms !important;   /* default is ~250ms; pick your value */
  transition-timing-function: linear !important;
}

.k-lpe-alba-button-instructions {
	font-size:18px;
	padding:16px 0;
	margin:4px 4px 4px 8px;
	text-align:center;
	font-weight:900;
	background-color:#333;
	color:#fff;
}

.k-lpe-ai-generated-warning {
	display:flex;
	align-items:center;
	background-color:$v-pink-lighten-5;
	border:1px solid $v-pink-darken-4;
	border-radius:4px;
	padding:4px 8px;
	font-size:14px;
	line-height:17px;
	margin-left:8px;
	transition: background-color 0.5s ease, color 0.5s ease;

	.fa-robot {
		font-size:18px;
		margin-top:-2px;
		margin-right:4px;
		color:$v-pink-darken-4;
		transition: background-color 0.5s ease, color 0.5s ease;
	}
}

.k-lpe-ai-generated-warning-em {
	background-color:$v-pink-darken-4;
	color:#fff;
	.fa-robot {
		color:#fff;
	}
}
</style>
